// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { useCart } from "../../../Context/CartContext";
// import { useLocation } from "react-router-dom";

// const BASE_URL = "https://ecom.cyberathon.com";

// function BillingDynamic() {
//   const navigate = useNavigate();

// const location = useLocation();

// const buyNowData = location.state?.product;
// const isBuyNow = location.state?.buyNow;
//   const userId = sessionStorage.getItem("userId");
//   const cartToken = localStorage.getItem("cart_token");

//   /* ================= STATE MANAGEMENT ================= */
//   const [paymentMode, setPaymentMode] = useState("Cash");
//   const [alertShown, setAlertShown] = useState(false);
//   const [cartItems, setCartItems] = useState([]);
//   const [coupons, setCoupons] = useState([]);
//   const [appliedCoupon, setAppliedCoupon] = useState(null);
//   const [isPlacingOrder, setIsPlacingOrder] = useState(false);
//   const { setCartCount } = useCart();
// // Shipping hide and show states
// const [shippingEnabled, setShippingEnabled] = useState(true);
// // Payment hide and show
// const [paymentSettings, setPaymentSettings] = useState({
//   prepaid: false,
//   cod: false,
// });
// const fetchPaymentSettings = async () => {
//   try {
//     const res = await axios.get(
//       `${BASE_URL}/index.php/Api/list_payment_setting`
//     );

//     if (res.data.status === true) {
//       const { prepaid, cod } = res.data.data;

//       setPaymentSettings({
//         prepaid: prepaid === 1,
//         cod: cod === 1,
//       });

//       // ✅ default payment mode
//       // if (cod === 1) {
//       //   setPaymentMode("Cash");
//       // } else if (prepaid === 1) {
//       //   setPaymentMode("Prepaid");
//       // }
//       // ❗ default sirf tab set karo jab kuch saved hi na ho
// const savedMode = localStorage.getItem("payment_mode");

// if (!savedMode) {
//   if (cod === 1) {
//     setPaymentMode("Cash");
//     localStorage.setItem("payment_mode", "Cash");
//   } else if (prepaid === 1) {
//     setPaymentMode("Prepaid");
//     localStorage.setItem("payment_mode", "Prepaid");
//   }
// }
//     }
//   } catch (err) {
//     console.error("Payment setting error", err);
//   }
// };
// useEffect(() => {
//   fetchPaymentSettings();
// }, []);
// useEffect(() => {
//   const savedMode = localStorage.getItem("payment_mode");
//   if (savedMode) {
//     setPaymentMode(savedMode);
//   }
// }, []);

// const fetchShippingSetting = async() =>{
//   try{
// const res = await axios.get(
//   `${BASE_URL}/index.php/Api/list_shipping_setting`
// );
// if(res.data.status === true){
//   setShippingEnabled(res.data.shipping_enabled === 1);
// }
//   }catch(error){
//     console.error("Shipping setting error", error);
//   }
// };
// useEffect(()=>{
//   fetchShippingSetting();
// },[]);
//   const [orderSummary, setOrderSummary] = useState({
//     subtotal: "0.00",
//     discount: "0.00",
//     shipping: "0.00",
//     grandTotal: "0.00",
//   });

//   const [form, setForm] = useState({
//     first_name: "",
//     last_name: "",
//     email: "",
//     phone: "",
//     company_name: "",
//     address1: "",
//     location: "",
//     city: "",
//     state: "",
//     pin_code: "",
//     address_type: "home",
//     add_information: "",
//   });
// // useEffect(() => {
// //   setAppliedCoupon(null);
// //   localStorage.removeItem("applied_coupon_id");
// // }, []);

//   const [addresses, setAddresses] = useState([]);
//   const [selectedAddress, setSelectedAddress] = useState(null);
//   const [isNewAddress, setIsNewAddress] = useState(false);

//   /* ================= FETCH CART ================= */
//   const fetchCart = async () => {
//  // ✅ Buy Now mode mein cart API skip karo
//   // if (buyNowData) {
//   //   const item = {
//   //     prod_id: Number(buyNowData.prod_id),
//   //     Product_name: buyNowData.Product_name,
//   //     current_price: Number(buyNowData.current_price),
//   //     cart_qty: Number(buyNowData.qty),
//   //      size_id: Number(buyNowData.size_id),
//   // size: buyNowData.size,
//   //     Product_image: buyNowData.Product_image,
//   //   };
//   //   setCartItems([item]);

//   //   const subtotal = (item.current_price * item.cart_qty).toFixed(2);
//   //   setOrderSummary({
//   //     subtotal: subtotal,
//   //     discount: "0.00",
//   //     shipping: "0.00",
//   //     grandTotal: subtotal,
//   //   });
//   //   return; // ← API call nahi hogi
//   // }

// if (isBuyNow && buyNowData) {

//   console.log("🟢 Buy Now Data:", buyNowData);

//   const item = {
//     prod_id: Number(buyNowData.prod_id),
//     Product_name: buyNowData.Product_name,
//     current_price: Number(buyNowData.current_price),
//     cart_qty: Number(buyNowData.qty),
//     // size_id: Number(buyNowData.size_id),
//     size_id: buyNowData.size_id ? Number(buyNowData.size_id) : null,
// price: Number(buyNowData.current_price),
//     size: buyNowData.size,
//     Product_image: buyNowData.Product_image,
//   };

//   setCartItems([item]);

//   const subtotal = (item.current_price * item.cart_qty).toFixed(2);
// if (shippingEnabled) {
//   calculateShipping([item]);
// }
//   setOrderSummary({
//     subtotal: subtotal,
//     discount: "0.00",
//     shipping: "0.00",
//     grandTotal: subtotal,
//   });

//   return;
// }

//     if (!userId && !cartToken) return;

//     try {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//         user_id: userId ? userId : null,
//         cart_token: userId ? null : cartToken,
//       });

//       console.log("🔴 Cart API Response:", res.data);

//       if (res.data.status) {
//         const mappedItems = (res.data.cart_items || []).map(item => ({
//           ...item,
//           prod_id: Number(item.prod_id),
//           cart_qty: Number(item.cart_qty),
//            size_id: Number(item.size_id),
//   size: item.size,
//           current_price: Number(item.current_price),
//           Product_name: item.Product_name,
//           Product_image: item.Product_image
//         }));

//         console.log("🔴 Mapped Cart Items:", mappedItems);
        
//         setCartItems(mappedItems);
// // ✅ CALL SHIPPING HERE
// if (shippingEnabled) {
//   calculateShipping(mappedItems);
// }
//         setOrderSummary({
//           subtotal: res.data.subtotal || "0.00",
//           discount: res.data.discount || "0.00",
//           // shipping: res.data.shipping_total || "0.00",
//           // grandTotal: res.data.grand_total || "0.00",
//   //         shipping: shippingAmount,
//   // grandTotal: shippingEnabled
//   //   ? res.data.grand_total
//   //   : (
//   //       parseFloat(res.data.subtotal || 0) -
//   //       parseFloat(res.data.discount || 0)
//   //     ).toFixed(2),
//   //       });
//  shipping: shippingEnabled 
//       ? res.data.shipping_total || "0.00"
//       : "0.00",
//   grandTotal: res.data.grand_total || "0.00",
// });
//         // if (res.data.applied_coupon_id) {
//         //   const coupon = coupons.find(c => c.coupon_id === res.data.applied_coupon_id);
//         //   if (coupon) {
//         //     setAppliedCoupon(coupon);
//         //   }
//         //   localStorage.setItem("applied_coupon_id", res.data.applied_coupon_id);
//         // }
//        if (res.data.applied_coupon_id) {
//   const coupon = coupons.find(
//     c => Number(c.coupon_id) === Number(res.data.applied_coupon_id)
//   );

//   if (coupon) {
//     setAppliedCoupon(coupon);
//     localStorage.setItem(
//       "applied_coupon_id",
//       res.data.applied_coupon_id
//     );
//   }
// } else {
//   setAppliedCoupon(null);
//   localStorage.removeItem("applied_coupon_id");
// }


//       } else {
//         setCartItems([]);
//       }
//     } catch (err) {
//       console.error("fetchCart error", err);
//     }
//   };

//   /* ================= FETCH COUPONS ================= */
//   const fetchCoupons = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/index.php/Api/list_coupon`);
//       setCoupons(res.data.data || []);
//     } catch (error) {
//       console.error("Coupon API Error:", error);
//     }
//   };

//   useEffect(() => {
//     fetchCoupons();
//   }, []);

//   useEffect(() => {
//     if (coupons.length > 0) {
//       fetchCart();
//     }
//   }, [userId, cartToken, coupons, shippingEnabled, isBuyNow]);

//   /* ================= LOGIN CHECK ================= */
//   // useEffect(() => {
//   //   if (!userId && !alertShown) {
//   //     alert("Please login to continue");
//   //     setAlertShown(true);
//   //     navigate("/");
//   //   }
//   // }, [userId, alertShown]);

//   useEffect(() => {

//   if (isBuyNow && buyNowData) return;

//   if (!userId && !alertShown) {

//     alert("Please login to continue");

//     sessionStorage.setItem("redirectAfterLogin", "/Bill");

//     window.dispatchEvent(new Event("openLoginModal"));

//     setAlertShown(true);

//   }

// }, [userId, alertShown, isBuyNow, buyNowData]);
// const calculateShipping = async (items) => {
//   try {
//     const res = await axios.post(`${BASE_URL}/calculate_shipping`, {
//       cart_items: items,
//     });

//     const shipping_total = parseFloat(res.data.shipping_price || 0);

//     setOrderSummary((prev) => ({
//       ...prev,
//       shipping: shipping_total.toFixed(2),
//       grandTotal: (
//         parseFloat(prev.subtotal) -
//         parseFloat(prev.discount) +
//         shipping_total
//       ).toFixed(2),
//     }));
//   } catch (err) {
//     console.error("Shipping error:", err);
//   }
// };

//   /* ================= FETCH ADDRESSES ================= */
//   const fetchAddresses = async () => {
//     if (!userId) return;

//     try {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/list_billing_address`, {
//         user_id: userId,
//       });
      
//       if (res.data.status) {
//         setAddresses(res.data.data || []);
//       }
//     } catch (error) {
//       console.error("Fetch addresses error:", error);
//     }
//   };

//   useEffect(() => {
//     fetchAddresses();
//   }, [userId]);

//   useEffect(() => {
//     if (addresses.length > 0 && !selectedAddress && !isNewAddress) {
//       setSelectedAddress(addresses[0]);
//     }
//   }, [addresses]);

//   /* ================= AUTO FILL ================= */
//   useEffect(() => {
//     if (!userId) return;

//     setForm((prev) => ({
//       ...prev,
//       first_name: sessionStorage.getItem("first_name") || "",
//       last_name: sessionStorage.getItem("last_name") || "",
//       email: sessionStorage.getItem("email") || "",
//       phone: sessionStorage.getItem("phone") || "",
//     }));
//   }, [userId]);

//   /* ================= HANDLERS ================= */
//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const addNewAddressToList = () => {
//     if (!form.first_name || !form.last_name) {
//       alert("Please enter first name and last name");
//       return;
//     }

//     if (!/^\d{6}$/.test(form.pin_code)) {
//       alert("Enter valid 6 digit pincode");
//       return;
//     }

//     if (!/^\d{10}$/.test(form.phone)) {
//       alert("Enter valid 10 digit phone number");
//       return;
//     }

//     if (!/^\S+@\S+\.\S+$/.test(form.email)) {
//       alert("Enter valid email address");
//       return;
//     }

//     if (!form.address1 || !form.city || !form.state) {
//       alert("Please fill all required address fields");
//       return;
//     }

//     const newAddress = {
//       ...form,
//       billing_id: "new",
//       isNew: true,
//     };

//     setSelectedAddress(newAddress);
//     setIsNewAddress(true);

//     alert("New address ready! Click 'PLACE ORDER' to continue.");

//     setForm({
//       first_name: sessionStorage.getItem("first_name") || "",
//       last_name: sessionStorage.getItem("last_name") || "",
//       email: sessionStorage.getItem("email") || "",
//       phone: sessionStorage.getItem("phone") || "",
//       company_name: "",
//       address1: "",
//       location: "",
//       city: "",
//       state: "",
//       pin_code: "",
//       address_type: "home",
//       add_information: "",
//     });
//   };

//   const handleSelectAddress = (addr) => {
//     setSelectedAddress(addr);
//     setIsNewAddress(false);
//   };

//   const handleApplyCoupon = async (coupon) => {
//     try {
//       const payload = {
//         coupon_id: coupon.coupon_id,
//         user_id: userId ? userId : null,
//         cart_token: userId ? null : cartToken,
//       };

//       const res = await axios.post(
//         `${BASE_URL}/index.php/Api/apply_coupon`,
//         payload
//       );

//       if (res.data.status) {
//         setAppliedCoupon(coupon);
//         localStorage.setItem("applied_coupon_id", coupon.coupon_id);
        
//         // setOrderSummary(prev => ({
//         //   ...prev,
//         //   discount: res.data.discount,
//         //   grandTotal: res.data.grand_total
//         // }));
        
//         alert(`Coupon applied! You saved ₹${res.data.discount}`);
//         await fetchCart();
//       } else {
//         alert(res.data.message || "Failed to apply coupon");
//       }
//     } catch (error) {
//       console.error("Apply coupon error:", error);
//     }
//   };

//   /* ================= 🚀 PLACE ORDER - DIRECT (NO PAYMENT PAGE) ================= */
//   const handlePlaceOrder = async () => {
//     console.log("🔴 ========== PLACE ORDER START ==========");
//     console.log("🔴 Cart Items:", cartItems);
//     console.log("🔴 Selected Address:", selectedAddress);
//     console.log("🔴 Payment Mode:", paymentMode);

//     if (isPlacingOrder) {
//       console.log("🔴 Already placing order");
//       return;
//     }

//     if (!selectedAddress) {
//       alert("Please select or add a delivery address");
//       return;
//     }

//     if (!cartItems || cartItems.length === 0) {
//       alert("Your cart is empty. Please add items first.");
//       navigate("/");
//       return;
//     }

//     // ✅ Validate prod_id exists
//     const invalidItems = cartItems.filter(item => !item.prod_id);
//     if (invalidItems.length > 0) {
//       console.error("🔴 Invalid items:", invalidItems);
//       alert("Cart items are invalid. Please refresh and try again.");
//       return;
//     }

//     setIsPlacingOrder(true);

//     try {
//       // ✅ Prepare cart items
//       // const cartItemsPayload = cartItems.map(item => ({
//       //   prod_id: Number(item.prod_id),
//       //   qty: Number(item.cart_qty)
//       // }));

//   //     const cartItemsPayload = buyNowData
//   // ? [{ prod_id: Number(buyNowData.prod_id), qty: Number(buyNowData.qty) }]
//   // : cartItems.map(item => ({
//   //     prod_id: Number(item.prod_id),
//   //     qty: Number(item.cart_qty)
//   //   }));

//   const cartItemsPayload = buyNowData
//   ? [
//       {
//         prod_id: Number(buyNowData.prod_id),
//         size_id: Number(buyNowData.size_id),
//         qty: Number(buyNowData.qty),
//         price: Number(buyNowData.current_price),
//       },
//     ]
//   : cartItems.map((item) => ({
//       prod_id: Number(item.prod_id),
//       size_id: Number(item.size_id),
//       qty: Number(item.cart_qty),
//     }));
//       console.log("🔴 Cart Items Payload:", cartItemsPayload);

//       // ✅ Prepare address
//     //   const addressPayload = {
//     //     first_name: selectedAddress.first_name,
//     //     last_name: selectedAddress.last_name,
//     //     email: selectedAddress.email,
//     //     phone: selectedAddress.phone,
//     //     company_name: selectedAddress.company_name || "",
//     //     address1: selectedAddress.address1,
//     //     location: selectedAddress.location || "",
//     //     city: selectedAddress.city,
//     //     state: selectedAddress.state,
//     //     pin_code: selectedAddress.pin_code,
//     //     address_type: selectedAddress.address_type,
//     //     add_information: selectedAddress.add_information || "",
//     //     country: "India",
//     //   };

//       // ✅ Full payload
//     //   const payload = {
//     //     user_id: Number(userId),
//     //     ...addressPayload,
//     //     cart_items: cartItemsPayload,
//     //     payment_mode: paymentMode,
//     //   };

// // const payload = {
// //   user_id: userId ? Number(userId) : null,
// //   cart_token: userId ? null : cartToken,
// //   ...addressPayload,
// //   cart_items: cartItemsPayload,
// //   payment_mode: paymentMode,
// // };
// // let payload = {
// //   user_id: Number(userId),
// //   cart_items: cartItemsPayload,
// //   payment_mode: paymentMode,
// // };
// let payload = {
//   user_id: userId ? Number(userId) : null,
//   // cart_token: cartToken || null,   // ✅ REQUIRED
//   cart_token: userId ? null : cartToken,
//   cart_items: cartItemsPayload,
//   payment_mode: paymentMode,
//   //  shipping_total: Number(orderSummary.shipping.replace(/,/g, "")),
//   shipping_total: shippingEnabled
//   ? Number(orderSummary.shipping.replace(/,/g, ""))
//   : 0,

// };

// // 🔹 CASE 1: SAVED ADDRESS (sirf billing_id)
// // if (!isNewAddress && selectedAddress?.billing_id) {
// //   payload.billing_id = Number(selectedAddress.billing_id);
// // }

// // if (!isNewAddress && selectedAddress) {
// //   payload = {
// //     ...payload,
// //     billing_id: Number(selectedAddress.billing_id),
// //     first_name: selectedAddress.first_name,
// //     last_name: selectedAddress.last_name,
// //     email: selectedAddress.email,
// //     phone: selectedAddress.phone,
// //     company_name: selectedAddress.company_name || "",
// //     address1: selectedAddress.address1,
// //     location: selectedAddress.location || "",
// //     city: selectedAddress.city,
// //     state: selectedAddress.state,
// //     pin_code: selectedAddress.pin_code,
// //     address_type: selectedAddress.address_type,
// //     add_information: selectedAddress.add_information || "",
// //     country: "India",
// //   };
// // }

// // if (isNewAddress && selectedAddress?.isNew) {
// //   payload = {
// //     ...payload,
// //     first_name: selectedAddress.first_name,
// //     last_name: selectedAddress.last_name,
// //     email: selectedAddress.email,
// //     phone: selectedAddress.phone,
// //     company_name: selectedAddress.company_name || "",
// //     address1: selectedAddress.address1,
// //     location: selectedAddress.location || "",
// //     city: selectedAddress.city,
// //     state: selectedAddress.state,
// //     pin_code: selectedAddress.pin_code,
// //     address_type: selectedAddress.address_type,
// //     add_information: selectedAddress.add_information || "",
// //     country: "India",
// //   };
// // }

// // if (appliedCouponId) {
// //   payload.coupon_id = Number(appliedCouponId);
// // }


//       // ✅ Add coupon if applied
    
//     // Saved address
// if (!isNewAddress && selectedAddress) {
//   payload = {
//     ...payload,
//     billing_id: Number(selectedAddress.billing_id),
//     first_name: selectedAddress.first_name,
//     last_name: selectedAddress.last_name,
//     email: selectedAddress.email,
//     phone: selectedAddress.phone,
//     company_name: selectedAddress.company_name || "",
//     address1: selectedAddress.address1,
//     location: selectedAddress.location || "",
//     city: selectedAddress.city,
//     state: selectedAddress.state,
//     pin_code: selectedAddress.pin_code,
//     address_type: selectedAddress.address_type,
//     add_information: selectedAddress.add_information || "",
//     country: "India",
//   };
// }



// // New address
// if (isNewAddress && selectedAddress?.isNew) {
//   payload = {
//     ...payload,
//     first_name: selectedAddress.first_name,
//     last_name: selectedAddress.last_name,
//     email: selectedAddress.email,
//     phone: selectedAddress.phone,
//     company_name: selectedAddress.company_name || "",
//     address1: selectedAddress.address1,
//     location: selectedAddress.location || "",
//     city: selectedAddress.city,
//     state: selectedAddress.state,
//     pin_code: selectedAddress.pin_code,
//     address_type: selectedAddress.address_type,
//     add_information: selectedAddress.add_information || "",
//     country: "India",
//   };
// }
    
//       const appliedCouponId = localStorage.getItem("applied_coupon_id");
//       if (appliedCouponId) {
//         payload.coupon_id = Number(appliedCouponId);
//       }

      
//       console.log("🔴 ========== FINAL PAYLOAD ==========");
//       console.log(JSON.stringify(payload, null, 2));

//       // ✅ DIRECT API CALL - NO PAYMENT PAGE
//       const res = await axios.post(
//         `${BASE_URL}/index.php/Api/place_order`,
//         payload
//       );

//       console.log("🔴 ========== API RESPONSE ==========");
//       console.log(res.data);

//       if (res.data.status === true || res.data.success === "1") {
//         console.log("🔴 ✅ Order Success!");
        
//         alert(`Order placed successfully!`);
        
//         // ✅ Clear storage
//         localStorage.removeItem("applied_coupon_id");
//         localStorage.removeItem("cart_token");
//         setCartCount(0);
//         // ✅ Refresh addresses
//         await fetchAddresses();
        
//         // ✅ Navigate to order confirmation
//         navigate("/order-confirm", { 
//           state: { 
//             orderId: res.data.order_id,
//             billingId: res.data.billing_id 
//           } 
//         });
//       } else {
//         console.log("🔴 ❌ Order Failed:", res.data.message);
//         alert(res.data.message || "Failed to place order");
//         setIsPlacingOrder(false);
//       }
//     } catch (error) {
//       console.error("🔴 ========== ERROR ==========");
//       console.error(error);
//       console.error(error.response?.data);
      
//       alert(`Error: ${error.response?.data?.message || error.message}`);
//       setIsPlacingOrder(false);
//     }
//   };

//   /* ================= COUPON FILTERING ================= */
//   const currentTotal = parseFloat(
//     orderSummary.subtotal.toString().replace(/,/g, "")
//   );



// const today = new Date();
// today.setHours(0, 0, 0, 0);

//   // const eligibleCoupons = coupons.filter(
//   //   (coupon) =>
//   //     coupon.status === "active" &&
//   //     currentTotal >= parseFloat(coupon.min_order_value.toString().replace(/,/g, ""))
//   // );

//   const eligibleCoupons = coupons.filter((coupon) => {
//   const currentTotalNum = parseFloat(
//     coupon.min_order_value.toString().replace(/,/g, "")
//   );

//   const couponEndDate = new Date(coupon.end_date);
//   couponEndDate.setHours(23, 59, 59, 999);

//   return (
//     coupon.status === "active" &&
//     currentTotal >= currentTotalNum &&
//     today <= couponEndDate   // ✅ expired coupon hide
//   );
// });

//   return (
//     <div className="container my-5">
//       <h4 className="fw-bold mb-4">BILLING DETAILS</h4>

//       <div className="row g-4">
//         {/* LEFT SIDE */}
//         <div className="col-md-8">
//           <div className="border p-4 rounded-2">
//             <h6 className="fw-bold mb-3">Billing Information</h6>

//             <div className="row g-md-4 g-3 mb-3">
//               <div className="col-md-6">
//                 <input
//                   name="first_name"
//                   value={form.first_name}
//                   onChange={handleChange}
//                   className="form-control "
//                   placeholder="First Name *"
//                 />
//               </div>
//               <div className="col-md-6">
//                 <input
//                   name="last_name"
//                   value={form.last_name}
//                   onChange={handleChange}
//                   className="form-control"
//                   placeholder="Last Name *"
//                 />
//               </div>
//             </div>

//             <div className="row mb-3 g-md-4 g-3">
//               <div className="col-md-6">
//                 <input
//                   name="email"
//                   value={form.email}
//                   onChange={handleChange}
//                   className="form-control"
//                   placeholder="Email *"
//                 />
//               </div>
//               <div className="col-md-6">
//                 <input
//                   name="phone"
//                   value={form.phone}
//                   onChange={handleChange}
//                   className="form-control"
//                   placeholder="Phone *"
//                 />
//               </div>
//             </div>

//             <input
//               name="company_name"
//               value={form.company_name}
//               onChange={handleChange}
//               className="form-control mb-3"
//               placeholder="Company Name (Optional)"
//             />

//             <h6 className="fw-bold mb-3">ADDRESS</h6>

//             <input
//               name="pin_code"
//               value={form.pin_code}
//               onChange={handleChange}
//               className="form-control mb-2"
//               placeholder="Pin Code *"
//             />
//             <input
//               name="address1"
//               value={form.address1}
//               onChange={handleChange}
//               className="form-control mb-2"
//               placeholder="Address *"
//             />
//             <input
//               name="location"
//               value={form.location}
//               onChange={handleChange}
//               className="form-control mb-2"
//               placeholder="Location"
//             />

//             <div className="row mb-3 g-md-4 g-2">
//               <div className="col-md-6">
//                 <input
//                   name="city"
//                   value={form.city}
//                   onChange={handleChange}
//                   className="form-control"
//                   placeholder="City *"
//                 />
//               </div>
//               <div className="col-md-6">
//                 <input
//                   name="state"
//                   value={form.state}
//                   onChange={handleChange}
//                   className="form-control"
//                   placeholder="State *"
//                 />
//               </div>
//             </div>

//             <textarea
//               name="add_information"
//               value={form.add_information}
//               onChange={handleChange}
//               className="form-control mb-3"
//               placeholder="Additional Information"
//               rows="2"
//             />

//             <strong>ADDRESS TYPE</strong>
//             <div className="mb-3">
//               <label className="me-3">
//                 <input
//                   type="radio"
//                   checked={form.address_type === "home"}
//                   onChange={() => setForm({ ...form, address_type: "home" })}
//                 />{" "}
//                 Home
//               </label>
//               <label>
//                 <input
//                   type="radio"
//                   checked={form.address_type === "office"}
//                   onChange={() => setForm({ ...form, address_type: "office" })}
//                 />{" "}
//                 Office
//               </label>
//             </div>

//             <button
//               onClick={addNewAddressToList}
//               className="bg-col text-white w-100 py-2 border-0 rounded-2 fw-bold mb-4"
//             >
//               ADD NEW ADDRESS
//             </button>

//             {/* SAVED ADDRESSES */}
//             {userId && (
//               <>
//                 <h6 className="fw-bold mb-3">
//                   {isNewAddress && selectedAddress?.isNew 
//                     ? "NEW ADDRESS (Will be saved)" 
//                     : "DELIVERY ADDRESS"}
//                 </h6>

//                 {isNewAddress && selectedAddress?.isNew && (
//                   <div className="border rounded-2 p-3 mb-3 bg-light">
//                     <label className="d-flex gap-2 w-100">
//                       <input type="radio" name="selectAddress" checked readOnly />
//                       <div>
//                         <p className="mb-1 fw-semibold">
//                           {selectedAddress.first_name} {selectedAddress.last_name}
//                           <span className="badge bg-success ms-2 small">NEW</span>
//                         </p>
//                         <p className="mb-1">{selectedAddress.address1}</p>
//                         <small>
//                           {selectedAddress.city}, {selectedAddress.state} - {selectedAddress.pin_code}
//                         </small>
//                       </div>
//                     </label>
//                   </div>
//                 )}

//                 {addresses.length === 0 && !isNewAddress && (
//                   <p className="text-muted">No saved addresses.</p>
//                 )}

//                 {addresses.map((addr) => (
//                   <div
//                     key={addr.billing_id}
//                     className={`border rounded-2 p-3 mb-3 ${
//                       !isNewAddress && selectedAddress?.billing_id === addr.billing_id 
//                         ? 'border-primary bg-light' 
//                         : ''
//                     }`}
//                   >
//                     <div className="d-flex justify-content-between">
//                       <label className="d-flex gap-2 w-100">
//                         <input
//                           type="radio"
//                           name="selectAddress"
//                           checked={!isNewAddress && selectedAddress?.billing_id === addr.billing_id}
//                           onChange={() => handleSelectAddress(addr)}
//                         />
//                         <div>
//                           <p className="mb-1 fw-semibold">
//                             {addr.first_name} {addr.last_name}
//                           </p>
//                           <p className="mb-1">{addr.address1}</p>
//                           <small>{addr.city}, {addr.state} - {addr.pin_code}</small>
//                         </div>
//                       </label>

//                       <button
//                         onClick={() => handleSelectAddress(addr)}
//                         className="bg-col text-white border-0 px-3 py-1 rounded-2"
//                       >
//                         DELIVER HERE
//                       </button>
//                     </div>
//                   </div>
//                 ))}
//               </>
//             )}
//           </div>
//         </div>

//         {/* RIGHT SIDE */}
//         <div className="col-md-4">
//           <h5 className="fw-bold mb-3">Payment Mode</h5>

//           {/* <div className="border rounded-2 mb-3">
//             <div className="p-3 border-bottom">
//               <label className="d-flex align-items-center">
//                 <input
//                   type="radio"
//                   checked={paymentMode === "Cash"}
//                   onChange={() => setPaymentMode("Cash")}
//                   className="me-2"
//                 />
//                 Cash On Delivery
//               </label>
//             </div>

//             <div className="p-3">
//               <label className="d-flex align-items-center">
//                 <input
//                   type="radio"
//                   checked={paymentMode === "Prepaid"}
//                   onChange={() => setPaymentMode("Prepaid")}
//                   className="me-2"
//                 />
//                 Prepaid
//               </label>
//             </div>
//           </div> */}
// <div
//   className={`p-3 border ${
//     !paymentSettings.cod ? "opacity-50" : ""
//   }`}
// >
//   <label className="d-flex align-items-center">
//     <input
//       type="radio"
//       disabled={!paymentSettings.cod}
//       checked={paymentMode === "Cash"}
//       onChange={() =>  {
//     setPaymentMode("Cash");
//     localStorage.setItem("payment_mode", "Cash");
//   }}
//       className="me-2"
//     />
//     Cash On Delivery
//     {!paymentSettings.cod && (
//       <small className="text-danger ms-2">(Disabled by Admin)</small>
//     )}
//   </label>
// </div>
// <div
//   className={`p-3 border ${
//     !paymentSettings.prepaid ? "opacity-50" : ""
//   }`}
// >
//   <label className="d-flex align-items-center">
//     <input
//       type="radio"
//       disabled={!paymentSettings.prepaid}
//       checked={paymentMode === "Prepaid"}
//       onChange={() => {
//     setPaymentMode("Prepaid");
//     localStorage.setItem("payment_mode", "Prepaid");
//   }}
//       className="me-2"
//     />
//     Prepaid (Online Payment)
//   </label>
// </div>

//           {/* COUPONS */}
//           {userId && (
//             <>
//               {/* <div className="border p-4 mb-4 mt-4">
//                 <h5 className="mb-3">Available Coupons</h5>

//                 {appliedCoupon && (
//                   <div className="alert alert-success py-2 px-3 mb-3">
//                     <small>✓ Coupon <strong>{appliedCoupon.code}</strong> applied</small>
//                   </div>
//                 )}

//                 {eligibleCoupons.slice(0, 2).map((coupon) => {
//                   const isApplied = appliedCoupon?.coupon_id === coupon.coupon_id;
                  
//                   return (
//                     <div
//                       key={coupon.coupon_id}
//                       className="border rounded-2 p-3 mb-3"
//                       style={{ backgroundColor: isApplied ? "#e8f5e9" : "#fff" }}
//                     >
//                       <h6 className="fw-bold mb-1">{coupon.coupon_name}</h6>
//                       <p className="text-primary mb-2 small">
//                         {coupon.discount_value}% OFF
//                       </p>

//                       <button
//                         onClick={() => handleApplyCoupon(coupon)}
//                         className="border-0 px-3 py-1 rounded-1 text-white small"
//                         style={{ backgroundColor: isApplied ? "#4caf50" : "#24aeb1" }}
//                         disabled={isApplied}
//                       >
//                         {isApplied ? "Applied" : "Apply"}
//                       </button>
//                     </div>
//                   );
//                 })}
//               </div> */}
// <div className="border p-4 shadow-sm  mt-3 mb-4">
//                 <div className="d-flex justify-content-between align-items-center mb-3">
//                   <h5 className="mb-0">Available Coupons</h5>
//                   <button
//                     onClick={() => navigate("/coupon")}
//                     className="btn btn-sm btn-link text-decoration-none"
//                   >
//                     Show All
//                   </button>
//                 </div>

//                 {appliedCoupon && (
//                   <div className="alert alert-success py-2 px-3 mb-3">
//                     <small>
//                       ✓ Coupon <strong>{appliedCoupon.code}</strong> applied
//                     </small>
//                   </div>
//                 )}

//                 {eligibleCoupons.length === 0 ? (
//                   <p className="text-muted small">
//                     No eligible coupons for your order.{" "}
//                     <span
//                       onClick={() => navigate("/coupon")}
//                       style={{
//                         color: "blue",
//                         cursor: "pointer",
//                         textDecoration: "underline",
//                       }}
//                     >
//                       View all coupons
//                     </span>
//                   </p>
//                 ) : (
//                   eligibleCoupons.map((coupon) => {
//                     const isApplied = appliedCoupon?.coupon_id === coupon.coupon_id;
                    
//                     return (
//                       <div
//                         key={coupon.coupon_id}
//                         className="border rounded-2 p-3 mb-3"
//                         style={{ backgroundColor: isApplied ? "#e8f5e9" : "#fff" }}
//                       >
//                         <h6 className="fw-bold mb-1">{coupon.coupon_name}</h6>
//                         <p className="text-primary mb-2 small">
//                           {coupon.discount_value}% OFF on orders above ₹
//                           {coupon.min_order_value}
//                         </p>

//                         <div className="d-flex justify-content-end align-items-center gap-2">
//                           <button
//                             onClick={() => handleApplyCoupon(coupon)}
//                             className="border-0 px-3 py-1 rounded-1 text-white small"
//                             style={{
//                               backgroundColor: isApplied ? "#4caf50" : "#24aeb1",
//                               cursor: isApplied ? "default" : "pointer",
//                             }}
//                             disabled={isApplied}
//                           >
//                             {isApplied ? "Applied" : "Apply"}
//                           </button>
//                         </div>
//                       </div>
//                     );
//                   })
//                 )}
//               </div>
//               {/* ORDER SUMMARY */}
//               <div className="border p-4">
//                 <h5 className="mb-3">Order Summary</h5>

//                 {/* {cartItems.map((item) => (
//                   <div key={item.prod_id} className="d-flex justify-content-between mb-2 small">
                  
//                     <span>
//   {item.Product_name}
//   {item.size && (
//     <small className="text-muted"> ({item.size} mm)</small>
//   )}
// </span>
//                     <span>{item.cart_qty} x ₹{item.current_price}</span>
//                   </div>
//                 ))} */}
// {cartItems.length > 0 ? (
//   cartItems.map((item) => (
//     <div key={item.prod_id} className="d-flex justify-content-between mb-2 small">

//       <span>
//         {item.Product_name}
//         {item.size && (
//           <small className="text-muted"> ({item.size} mm)</small>
//         )}
//       </span>

//       <span>
//         {item.cart_qty} x ₹{item.current_price}
//       </span>

//     </div>
//   ))
// ) : (
//   <p className="text-muted">No product found</p>
// )}
//                 <hr />

//                 <div className="d-flex justify-content-between mb-2">
//                   <span>Subtotal</span>
//                   <span>₹{orderSummary.subtotal}</span>
//                 </div>

               
// <div className="d-flex justify-content-between mb-2">
//   <span>Shipping</span>
//   <span>
//     ₹{shippingEnabled ? orderSummary.shipping : "0.00"}
//   </span>
// </div>


//                 {parseFloat(orderSummary.discount) > 0 && (
//                   <div className="d-flex justify-content-between mb-2 text-success">
//                     <span>Discount</span>
//                     <span>- ₹{orderSummary.discount}</span>
//                   </div>
//                 )}

//                 <hr />

//                 <div className="d-flex justify-content-between fw-bold mb-3">
//                   <span>Total</span>
//                   <span>₹{orderSummary.grandTotal}</span>
//                 </div>

//                 <button
//                   onClick={handlePlaceOrder}
//                   className="bg-col text-white w-100 py-2 border-0 rounded-2 fw-bold"
//                   disabled={!selectedAddress || isPlacingOrder}
//                 >
//                   {isPlacingOrder ? "PLACING ORDER..." : "PLACE ORDER"}
//                 </button>

//                 {!selectedAddress && (
//                   <small className="text-danger d-block mt-2 text-center">
//                     Please select an address
//                   </small>
//                 )}
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default BillingDynamic;


// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { useCart } from "../../../Context/CartContext";
// import { useLocation } from "react-router-dom";

// const BASE_URL = "https://ecom.cyberathon.com";

// function BillingDynamic() {
//   const navigate = useNavigate();

//   const location = useLocation();
//   // const buyNowData = location.state?.product;
//  let storedProduct = null;

// try {
//   storedProduct = sessionStorage.getItem("buyNowProduct");
//   storedProduct = storedProduct ? JSON.parse(storedProduct) : null;
// } catch (e) {
//   storedProduct = null;
// }

// const buyNowData = location.state?.product || storedProduct;
//   // const isBuyNow = location.state?.buyNow;
// const isBuyNow = location.state?.buyNow || !!buyNowData;
//   const userId = sessionStorage.getItem("userId");
//   const cartToken = localStorage.getItem("cart_token");

//   /* ================= STATE MANAGEMENT ================= */
//   const [paymentMode, setPaymentMode] = useState("Cash");
//   const [alertShown, setAlertShown] = useState(false);
//   const [cartItems, setCartItems] = useState([]);
//   const [coupons, setCoupons] = useState([]);
//   const [appliedCoupon, setAppliedCoupon] = useState(null);
//   const [isPlacingOrder, setIsPlacingOrder] = useState(false);
//   const { setCartCount } = useCart();

//   const [shippingEnabled, setShippingEnabled] = useState(true);

//   const [paymentSettings, setPaymentSettings] = useState({
//     prepaid: false,
//     cod: false,
//   });

//   const [orderSummary, setOrderSummary] = useState({
//     subtotal: "0.00",
//     discount: "0.00",
//     shipping: "0.00",
//     grandTotal: "0.00",
//   });
// // ✅ Helper function — add this at the top of BillingDynamic.jsx
// const parsePrice = (val) => parseFloat(String(val || "0").replace(/,/g, "")) || 0;
//   const [form, setForm] = useState({
//     first_name: "",
//     last_name: "",
//     email: "",
//     phone: "",
//     company_name: "",
//     address1: "",
//     location: "",
//     city: "",
//     state: "",
//     pin_code: "",
//     address_type: "home",
//     add_information: "",
//   });

//   const [addresses, setAddresses] = useState([]);
//   const [selectedAddress, setSelectedAddress] = useState(null);
//   const [isNewAddress, setIsNewAddress] = useState(false);

//   /* ================= PAYMENT SETTINGS ================= */
//   const fetchPaymentSettings = async () => {
//     try {
//       const res = await axios.get(
//         `${BASE_URL}/index.php/Api/list_payment_setting`
//       );
//       if (res.data.status === true) {
//         const { prepaid, cod } = res.data.data;
//         setPaymentSettings({
//           prepaid: prepaid === 1,
//           cod: cod === 1,
//         });
//         const savedMode = localStorage.getItem("payment_mode");
//         if (!savedMode) {
//           if (cod === 1) {
//             setPaymentMode("Cash");
//             localStorage.setItem("payment_mode", "Cash");
//           } else if (prepaid === 1) {
//             setPaymentMode("Prepaid");
//             localStorage.setItem("payment_mode", "Prepaid");
//           }
//         }
//       }
//     } catch (err) {
//       console.error("Payment setting error", err);
//     }
//   };

//   useEffect(() => {
//     fetchPaymentSettings();
//   }, []);

//   useEffect(() => {
//     const savedMode = localStorage.getItem("payment_mode");
//     if (savedMode) {
//       setPaymentMode(savedMode);
//     }
//   }, []);
// useEffect(() => {
//   if (location.state?.product) {
//     sessionStorage.setItem(
//       "buyNowProduct",
//       JSON.stringify(location.state.product)
//     );
//   }
// }, [location.state]);
//   /* ================= SHIPPING SETTINGS ================= */
//   const fetchShippingSetting = async () => {
//     try {
//       const res = await axios.get(
//         `${BASE_URL}/index.php/Api/list_shipping_setting`
//       );
//       if (res.data.status === true) {
//         setShippingEnabled(res.data.shipping_enabled === 1);
//       }
//     } catch (error) {
//       console.error("Shipping setting error", error);
//     }
//   };

//   useEffect(() => {
//     fetchShippingSetting();
//   }, []);

//   /* ================= CALCULATE SHIPPING ================= */
//   // const calculateShipping = async (items) => {
//   //   try {
//   //     const res = await axios.post(`${BASE_URL}/index.php/Api/calculate_shipping`, {
//   //       cart_items: items,
//   //     });
//   //     const shipping_total = parseFloat(res.data.shipping_price || 0);
//   //     setOrderSummary((prev) => ({
//   //       ...prev,
//   //       shipping: shipping_total.toFixed(2),
//   //       grandTotal: (
//   //         parseFloat(prev.subtotal) -
//   //         parseFloat(prev.discount) +
//   //         shipping_total
//   //       ).toFixed(2),
//   //     }));
//   //   } catch (err) {
//   //     console.error("Shipping error:", err);
//   //   }
//   // };

//   const calculateShipping = async (items) => {
//   try {
//     const res = await axios.post(`${BASE_URL}/index.php/Api/calculate_shipping`, {
//       cart_items: items,
//     });
//     const shipping_total = parsePrice(res.data.shipping_price);

//     setOrderSummary((prev) => ({
//       ...prev,
//       shipping: shipping_total.toFixed(2),
//       grandTotal: (
//         parsePrice(prev.subtotal) -
//         parsePrice(prev.discount) +   // ✅ parsePrice handles commas here too
//         shipping_total
//       ).toFixed(2),
//     }));
//   } catch (err) {
//     console.error("Shipping error:", err);
//   }
// };

//   /* ================= FETCH CART ================= */
//   const fetchCart = async () => {

//     // ✅ Buy Now mode — skip cart API, use passed product data directly
//     if (isBuyNow && buyNowData) {
//       console.log("🟢 Buy Now Data:", buyNowData);

//       const item = {
//         prod_id: Number(buyNowData.prod_id),
//         Product_name: buyNowData.Product_name,
//         // ✅ FIX: use variant_price if available, else current_price
//         current_price: Number(buyNowData.variant_price || buyNowData.current_price),
//         cart_qty: Number(buyNowData.qty),
//         size_id: buyNowData.size_id ? Number(buyNowData.size_id) : null,
//         size: buyNowData.size,
//         Product_image: buyNowData.Product_image,
//         product_type: buyNowData.product_type || "product",
//          weight: Number(buyNowData.weight || 0),
//       };

//       setCartItems([item]);

//       // const subtotal = (item.current_price * item.cart_qty).toFixed(2);
//  const subtotal = item.current_price * item.cart_qty;
//  // ✅ Apply coupon to buy-now order summary too
//   const savedCouponId = localStorage.getItem("applied_coupon_id");
//   let discount = 0;
//   if (savedCouponId && coupons.length > 0) {
//     const coupon = coupons.find(c => Number(c.coupon_id) === Number(savedCouponId));
//     if (coupon && subtotal >= parseFloat(coupon.min_order_value || 0)) {
//       if (coupon.discount_type === "percent") {
//         discount = (subtotal * parseFloat(coupon.discount_value)) / 100;
//         if (coupon.max_discount) discount = Math.min(discount, parseFloat(coupon.max_discount));
//       } else {
//         discount = parseFloat(coupon.discount_value);
//       }
//       discount = Math.min(discount, subtotal);
//       setAppliedCoupon(coupon);
//     }
//   }

//   const digitalTypes = ["ebook", "coursesection", "video"];
//   const isDigital = digitalTypes.includes(item.product_type);

//   setOrderSummary({
//     subtotal: subtotal.toFixed(2),
//     discount: discount.toFixed(2),
//     shipping: "0.00",
//     grandTotal: (subtotal - discount).toFixed(2),
//   });
  
//       // ✅ Only calculate shipping if enabled AND it's a physical product
//       if (shippingEnabled && !["ebook", "coursesection", "video"].includes(item.product_type)) {
//         // calculateShipping([item]);
//         calculateShipping([
//   {
//     weight: item.weight,
//     qty: item.cart_qty,
//   },
// ]);
//       }

//       // setOrderSummary({
//       //   subtotal: subtotal,
//       //   discount: "0.00",
//       //   shipping: "0.00",
//       //   grandTotal: subtotal,
//       // });

//       return;
//     }

//     if (!userId && !cartToken) return;

//     try {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//         user_id: userId ? userId : null,
//         cart_token: userId ? null : cartToken,
//       });

//       console.log("🔴 Cart API Response:", res.data);

//       if (res.data.status) {
//         const mappedItems = (res.data.cart_items || []).map((item) => ({
//           ...item,
//           prod_id: Number(item.prod_id),
//           cart_qty: Number(item.cart_qty),
//           size_id: item.size_id ? Number(item.size_id) : null,
//           size: item.size,
//           // ✅ FIX: variant_price takes priority (already handled in list_cart backend)
//           current_price: Number(item.current_price),
//           Product_name: item.Product_name,
//           Product_image: item.Product_image,
//           product_type: item.product_type || "product",
//         }));

//         console.log("🔴 Mapped Cart Items:", mappedItems);
//         setCartItems(mappedItems);

//          const subtotal  = parsePrice(res.data.subtotal);
//   const discount  = parsePrice(res.data.discount);
//   const shipping  = shippingEnabled ? parsePrice(res.data.shipping_total) : 0;
//   const grandTotal = subtotal - discount + shipping;

//         // ✅ Only call shipping if enabled
//         // if (shippingEnabled) {
//         //   calculateShipping(mappedItems);
//         // }

//         // setOrderSummary({
//         //   subtotal: res.data.subtotal || "0.00",
//         //   discount: res.data.discount || "0.00",
//         //   shipping: shippingEnabled ? res.data.shipping_total || "0.00" : "0.00",
//         //   grandTotal: res.data.grand_total || "0.00",
//         // });
//  setOrderSummary({
//     subtotal:   subtotal.toFixed(2),
//     discount:   discount.toFixed(2),
//     shipping:   shipping.toFixed(2),
//     grandTotal: grandTotal.toFixed(2),
//   });
//   // ✅ calculateShipping will update shipping+grandTotal on top of the correct subtotal/discount
//   if (shippingEnabled) {
//     calculateShipping(mappedItems);
//   }
//         if (res.data.applied_coupon_id) {
//           const coupon = coupons.find(
//             (c) => Number(c.coupon_id) === Number(res.data.applied_coupon_id)
//           );
//           if (coupon) {
//             setAppliedCoupon(coupon);
//             localStorage.setItem("applied_coupon_id", res.data.applied_coupon_id);
//           }
//         } else {
//           setAppliedCoupon(null);
//           localStorage.removeItem("applied_coupon_id");
//         }
//       } else {
//         setCartItems([]);
//       }
//     } catch (err) {
//       console.error("fetchCart error", err);
//     }
//   };

//   /* ================= FETCH COUPONS ================= */
//   const fetchCoupons = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/index.php/Api/list_coupon`);
//       setCoupons(res.data.data || []);
//     } catch (error) {
//       console.error("Coupon API Error:", error);
//     }
//   };

//   useEffect(() => {
//     fetchCoupons();
//   }, []);

//   useEffect(() => {
//     if (coupons.length > 0) {
//       fetchCart();
//     }
//   }, [userId, cartToken, coupons, shippingEnabled, isBuyNow]);

//   /* ================= LOGIN CHECK ================= */
//   useEffect(() => {
//     if (isBuyNow && buyNowData) return;
//     if (!userId && !alertShown) {
//       alert("Please login to continue");
//       sessionStorage.setItem("redirectAfterLogin", "/Bill");
//       window.dispatchEvent(new Event("openLoginModal"));
//       setAlertShown(true);
//     }
//   }, [userId, alertShown, isBuyNow, buyNowData]);

//   /* ================= FETCH ADDRESSES ================= */
//   const fetchAddresses = async () => {
//     if (!userId) return;
//     try {
//       const res = await axios.post(
//         `${BASE_URL}/index.php/Api/list_billing_address`,
//         { user_id: userId }
//       );
//       if (res.data.status) {
//         setAddresses(res.data.data || []);
//       }
//     } catch (error) {
//       console.error("Fetch addresses error:", error);
//     }
//   };

//   useEffect(() => {
//     fetchAddresses();
//   }, [userId]);

//   useEffect(() => {
//     if (addresses.length > 0 && !selectedAddress && !isNewAddress) {
//       setSelectedAddress(addresses[0]);
//     }
//   }, [addresses]);

//   /* ================= AUTO FILL FORM ================= */
//   useEffect(() => {
//     if (!userId) return;
//     setForm((prev) => ({
//       ...prev,
//       first_name: sessionStorage.getItem("first_name") || "",
//       last_name: sessionStorage.getItem("last_name") || "",
//       email: sessionStorage.getItem("email") || "",
//       phone: sessionStorage.getItem("phone") || "",
//     }));
//   }, [userId]);

//   /* ================= HANDLERS ================= */
//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const addNewAddressToList = () => {
//     if (!form.first_name || !form.last_name) {
//       alert("Please enter first name and last name");
//       return;
//     }
//     if (!/^\d{6}$/.test(form.pin_code)) {
//       alert("Enter valid 6 digit pincode");
//       return;
//     }
//     if (!/^\d{10}$/.test(form.phone)) {
//       alert("Enter valid 10 digit phone number");
//       return;
//     }
//     if (!/^\S+@\S+\.\S+$/.test(form.email)) {
//       alert("Enter valid email address");
//       return;
//     }
//     if (!form.address1 || !form.city || !form.state) {
//       alert("Please fill all required address fields");
//       return;
//     }

//     const newAddress = { ...form, billing_id: "new", isNew: true };
//     setSelectedAddress(newAddress);
//     setIsNewAddress(true);
//     alert("New address ready! Click 'PLACE ORDER' to continue.");

//     setForm({
//       first_name: sessionStorage.getItem("first_name") || "",
//       last_name: sessionStorage.getItem("last_name") || "",
//       email: sessionStorage.getItem("email") || "",
//       phone: sessionStorage.getItem("phone") || "",
//       company_name: "",
//       address1: "",
//       location: "",
//       city: "",
//       state: "",
//       pin_code: "",
//       address_type: "home",
//       add_information: "",
//     });
//   };

//   const handleSelectAddress = (addr) => {
//     setSelectedAddress(addr);
//     setIsNewAddress(false);
//   };

//   const handleApplyCoupon = async (coupon) => {
//     try {
//       const payload = {
//         coupon_id: coupon.coupon_id,
//         user_id: userId ? userId : null,
//         cart_token: userId ? null : cartToken,
//       };
//       const res = await axios.post(
//         `${BASE_URL}/index.php/Api/apply_coupon`,
//         payload
//       );
//       if (res.data.status) {
//         setAppliedCoupon(coupon);
//         localStorage.setItem("applied_coupon_id", coupon.coupon_id);
//         alert(`Coupon applied! You saved ₹${res.data.discount}`);
//         await fetchCart();
//       } else {
//         alert(res.data.message || "Failed to apply coupon");
//       }
//     } catch (error) {
//       console.error("Apply coupon error:", error);
//     }
//   };

//   /* ================= 🚀 PLACE ORDER ================= */
//   const handlePlaceOrder = async () => {
//     console.log("🔴 ========== PLACE ORDER START ==========");
//     console.log("🔴 Cart Items:", cartItems);
//     console.log("🔴 Selected Address:", selectedAddress);
//     console.log("🔴 Payment Mode:", paymentMode);

//     if (isPlacingOrder) return;

//     if (!selectedAddress) {
//       alert("Please select or add a delivery address");
//       return;
//     }

//     if (!cartItems || cartItems.length === 0) {
//       alert("Your cart is empty. Please add items first.");
//       navigate("/");
//       return;
//     }

//     const invalidItems = cartItems.filter((item) => !item.prod_id);
//     if (invalidItems.length > 0) {
//       alert("Cart items are invalid. Please refresh and try again.");
//       return;
//     }

//     setIsPlacingOrder(true);

//     try {
//       // ✅ FIX: Always send price for every item (cart + buy now)
//       // This is the MAIN fix — backend uses price field first, so sending it
//       // ensures ebooks, courses, and products all get correct price in order list
//       const cartItemsPayload = buyNowData
//         ? [
//             {
//               prod_id: Number(buyNowData.prod_id),
//               size_id: buyNowData.size_id ? Number(buyNowData.size_id) : null,
//               qty: Number(buyNowData.qty),
//               // ✅ FIX: Send the actual price (variant_price or current_price)
//               price: Number(buyNowData.variant_price || buyNowData.current_price),
//             },
//           ]
//         : cartItems.map((item) => ({
//             prod_id: Number(item.prod_id),
//             size_id: item.size_id ? Number(item.size_id) : null,
//             qty: Number(item.cart_qty),
//             // ✅ FIX: Send price for every cart item — fixes ebook/course/product 0 price bug
//             price: Number(item.current_price),
//           }));

//       console.log("🔴 Cart Items Payload:", cartItemsPayload);

//       let payload = {
//         user_id: userId ? Number(userId) : null,
//         cart_token: userId ? null : cartToken,
//         cart_items: cartItemsPayload,
//         payment_mode: paymentMode,
//         // ✅ Only send shipping if enabled (backend also checks product_type)
//         shipping_total: shippingEnabled
//           ? Number(orderSummary.shipping.replace(/,/g, ""))
//           : 0,
//       };

//       // Saved address
//       if (!isNewAddress && selectedAddress) {
//         payload = {
//           ...payload,
//           billing_id: Number(selectedAddress.billing_id),
//           first_name: selectedAddress.first_name,
//           last_name: selectedAddress.last_name,
//           email: selectedAddress.email,
//           phone: selectedAddress.phone,
//           company_name: selectedAddress.company_name || "",
//           address1: selectedAddress.address1,
//           location: selectedAddress.location || "",
//           city: selectedAddress.city,
//           state: selectedAddress.state,
//           pin_code: selectedAddress.pin_code,
//           address_type: selectedAddress.address_type,
//           add_information: selectedAddress.add_information || "",
//           country: "India",
//         };
//       }

//       // New address
//       if (isNewAddress && selectedAddress?.isNew) {
//         payload = {
//           ...payload,
//           first_name: selectedAddress.first_name,
//           last_name: selectedAddress.last_name,
//           email: selectedAddress.email,
//           phone: selectedAddress.phone,
//           company_name: selectedAddress.company_name || "",
//           address1: selectedAddress.address1,
//           location: selectedAddress.location || "",
//           city: selectedAddress.city,
//           state: selectedAddress.state,
//           pin_code: selectedAddress.pin_code,
//           address_type: selectedAddress.address_type,
//           add_information: selectedAddress.add_information || "",
//           country: "India",
//         };
//       }

//       // Apply coupon if any
//       const appliedCouponId = localStorage.getItem("applied_coupon_id");
//       if (appliedCouponId) {
//         payload.coupon_id = Number(appliedCouponId);
//       }

//       console.log("🔴 ========== FINAL PAYLOAD ==========");
//       console.log(JSON.stringify(payload, null, 2));

//       const res = await axios.post(
//         `${BASE_URL}/index.php/Api/place_order`,
//         payload
//       );

//       console.log("🔴 ========== API RESPONSE ==========");
//       console.log(res.data);

//       if (res.data.status === true || res.data.success === "1") {
//         sessionStorage.removeItem("buyNowProduct");
//         console.log("🔴 ✅ Order Success!");
//         alert(`Order placed successfully!`);

//         localStorage.removeItem("applied_coupon_id");
//         localStorage.removeItem("cart_token");
//         setCartCount(0);
//         await fetchAddresses();

//         navigate("/order-confirm", {
//           state: {
//             orderId: res.data.order_id,
//             billingId: res.data.billing_id,
//           },
//         });
//       } else {
//         console.log("🔴 ❌ Order Failed:", res.data.message);
//         alert(res.data.message || "Failed to place order");
//         setIsPlacingOrder(false);
//       }
//     } catch (error) {
//       console.error("🔴 ========== ERROR ==========");
//       console.error(error);
//       alert(`Error: ${error.response?.data?.message || error.message}`);
//       setIsPlacingOrder(false);
//     }
//   };

//   /* ================= COUPON FILTERING ================= */
//   const currentTotal = parseFloat(
//     orderSummary.subtotal.toString().replace(/,/g, "")
//   );

//   const today = new Date();
//   today.setHours(0, 0, 0, 0);

//   const eligibleCoupons = coupons.filter((coupon) => {
//     const currentTotalNum = parseFloat(
//       coupon.min_order_value.toString().replace(/,/g, "")
//     );
//     const couponEndDate = new Date(coupon.end_date);
//     couponEndDate.setHours(23, 59, 59, 999);
//     return (
//       coupon.status === "active" &&
//       currentTotal >= currentTotalNum &&
//       today <= couponEndDate
//     );
//   });

//   /* ================= RENDER ================= */
//   return (
//     <div className="container my-5">
//       <h4 className="fw-bold mb-4">BILLING DETAILS</h4>

//       <div className="row g-4">
//         {/* LEFT SIDE */}
//         <div className="col-md-8">
//           <div className="border p-4 rounded-2">
//             <h6 className="fw-bold mb-3">Billing Information</h6>

//             <div className="row g-md-4 g-3 mb-3">
//               <div className="col-md-6">
//                 <input
//                   name="first_name"
//                   value={form.first_name}
//                   onChange={handleChange}
//                   className="form-control"
//                   placeholder="First Name *"
//                 />
//               </div>
//               <div className="col-md-6">
//                 <input
//                   name="last_name"
//                   value={form.last_name}
//                   onChange={handleChange}
//                   className="form-control"
//                   placeholder="Last Name *"
//                 />
//               </div>
//             </div>

//             <div className="row mb-3 g-md-4 g-3">
//               <div className="col-md-6">
//                 <input
//                   name="email"
//                   value={form.email}
//                   onChange={handleChange}
//                   className="form-control"
//                   placeholder="Email *"
//                 />
//               </div>
//               <div className="col-md-6">
//                 <input
//                   name="phone"
//                   value={form.phone}
//                   onChange={handleChange}
//                   className="form-control"
//                   placeholder="Phone *"
//                 />
//               </div>
//             </div>

//             <input
//               name="company_name"
//               value={form.company_name}
//               onChange={handleChange}
//               className="form-control mb-3"
//               placeholder="Company Name (Optional)"
//             />

//             <h6 className="fw-bold mb-3">ADDRESS</h6>

//             <input
//               name="pin_code"
//               value={form.pin_code}
//               onChange={handleChange}
//               className="form-control mb-2"
//               placeholder="Pin Code *"
//             />
//             <input
//               name="address1"
//               value={form.address1}
//               onChange={handleChange}
//               className="form-control mb-2"
//               placeholder="Address *"
//             />
//             <input
//               name="location"
//               value={form.location}
//               onChange={handleChange}
//               className="form-control mb-2"
//               placeholder="Location"
//             />

//             <div className="row mb-3 g-md-4 g-2">
//               <div className="col-md-6">
//                 <input
//                   name="city"
//                   value={form.city}
//                   onChange={handleChange}
//                   className="form-control"
//                   placeholder="City *"
//                 />
//               </div>
//               <div className="col-md-6">
//                 <input
//                   name="state"
//                   value={form.state}
//                   onChange={handleChange}
//                   className="form-control"
//                   placeholder="State *"
//                 />
//               </div>
//             </div>

//             <textarea
//               name="add_information"
//               value={form.add_information}
//               onChange={handleChange}
//               className="form-control mb-3"
//               placeholder="Additional Information"
//               rows="2"
//             />

//             <strong>ADDRESS TYPE</strong>
//             <div className="mb-3">
//               <label className="me-3">
//                 <input
//                   type="radio"
//                   checked={form.address_type === "home"}
//                   onChange={() => setForm({ ...form, address_type: "home" })}
//                 />{" "}
//                 Home
//               </label>
//               <label>
//                 <input
//                   type="radio"
//                   checked={form.address_type === "office"}
//                   onChange={() => setForm({ ...form, address_type: "office" })}
//                 />{" "}
//                 Office
//               </label>
//             </div>

//             <button
//               onClick={addNewAddressToList}
//               className="bg-col text-white w-100 py-2 border-0 rounded-2 fw-bold mb-4"
//             >
//               ADD NEW ADDRESS
//             </button>

//             {/* SAVED ADDRESSES */}
//             {userId && (
//               <>
//                 <h6 className="fw-bold mb-3">
//                   {isNewAddress && selectedAddress?.isNew
//                     ? "NEW ADDRESS (Will be saved)"
//                     : "DELIVERY ADDRESS"}
//                 </h6>

//                 {isNewAddress && selectedAddress?.isNew && (
//                   <div className="border rounded-2 p-3 mb-3 bg-light">
//                     <label className="d-flex gap-2 w-100">
//                       <input type="radio" name="selectAddress" checked readOnly />
//                       <div>
//                         <p className="mb-1 fw-semibold">
//                           {selectedAddress.first_name} {selectedAddress.last_name}
//                           <span className="badge bg-success ms-2 small">NEW</span>
//                         </p>
//                         <p className="mb-1">{selectedAddress.address1}</p>
//                         <small>
//                           {selectedAddress.city}, {selectedAddress.state} -{" "}
//                           {selectedAddress.pin_code}
//                         </small>
//                       </div>
//                     </label>
//                   </div>
//                 )}

//                 {addresses.length === 0 && !isNewAddress && (
//                   <p className="text-muted">No saved addresses.</p>
//                 )}

//                 {addresses.map((addr) => (
//                   <div
//                     key={addr.billing_id}
//                     className={`border rounded-2 p-3 mb-3 ${
//                       !isNewAddress &&
//                       selectedAddress?.billing_id === addr.billing_id
//                         ? "border-primary bg-light"
//                         : ""
//                     }`}
//                   >
//                     <div className="d-flex justify-content-between">
//                       <label className="d-flex gap-2 w-100">
//                         <input
//                           type="radio"
//                           name="selectAddress"
//                           checked={
//                             !isNewAddress &&
//                             selectedAddress?.billing_id === addr.billing_id
//                           }
//                           onChange={() => handleSelectAddress(addr)}
//                         />
//                         <div>
//                           <p className="mb-1 fw-semibold">
//                             {addr.first_name} {addr.last_name}
//                           </p>
//                           <p className="mb-1">{addr.address1}</p>
//                           <small>
//                             {addr.city}, {addr.state} - {addr.pin_code}
//                           </small>
//                         </div>
//                       </label>
//                       <button
//                         onClick={() => handleSelectAddress(addr)}
//                         className="bg-col text-white border-0 px-3 py-1 rounded-2"
//                       >
//                         DELIVER HERE
//                       </button>
//                     </div>
//                   </div>
//                 ))}
//               </>
//             )}
//           </div>
//         </div>

//         {/* RIGHT SIDE */}
//         <div className="col-md-4">
//           <h5 className="fw-bold mb-3">Payment Mode</h5>

//           <div
//             className={`p-3 border ${!paymentSettings.cod ? "opacity-50" : ""}`}
//           >
//             <label className="d-flex align-items-center">
//               <input
//                 type="radio"
//                 disabled={!paymentSettings.cod}
//                 checked={paymentMode === "Cash"}
//                 onChange={() => {
//                   setPaymentMode("Cash");
//                   localStorage.setItem("payment_mode", "Cash");
//                 }}
//                 className="me-2"
//               />
//               Cash On Delivery
//               {!paymentSettings.cod && (
//                 <small className="text-danger ms-2">(Disabled by Admin)</small>
//               )}
//             </label>
//           </div>

//           <div
//             className={`p-3 border ${
//               !paymentSettings.prepaid ? "opacity-50" : ""
//             }`}
//           >
//             <label className="d-flex align-items-center">
//               <input
//                 type="radio"
//                 disabled={!paymentSettings.prepaid}
//                 checked={paymentMode === "Prepaid"}
//                 onChange={() => {
//                   setPaymentMode("Prepaid");
//                   localStorage.setItem("payment_mode", "Prepaid");
//                 }}
//                 className="me-2"
//               />
//               Prepaid (Online Payment)
//             </label>
//           </div>

//           {/* COUPONS */}
//           {userId && (
//             <>
//               <div className="border p-4 shadow-sm mt-3 mb-4">
//                 <div className="d-flex justify-content-between align-items-center mb-3">
//                   <h5 className="mb-0">Available Coupons</h5>
//                   <button
//                     onClick={() => navigate("/coupon")}
//                     className="btn btn-sm btn-link text-decoration-none"
//                   >
//                     Show All
//                   </button>
//                 </div>

//                 {appliedCoupon && (
//                   <div className="alert alert-success py-2 px-3 mb-3">
//                     <small>
//                       ✓ Coupon <strong>{appliedCoupon.code}</strong> applied
//                     </small>
//                   </div>
//                 )}

//                 {eligibleCoupons.length === 0 ? (
//                   <p className="text-muted small">
//                     No eligible coupons for your order.{" "}
//                     <span
//                       onClick={() => navigate("/coupon")}
//                       style={{
//                         color: "blue",
//                         cursor: "pointer",
//                         textDecoration: "underline",
//                       }}
//                     >
//                       View all coupons
//                     </span>
//                   </p>
//                 ) : (
//                   eligibleCoupons.map((coupon) => {
//                     const isApplied =
//                       appliedCoupon?.coupon_id === coupon.coupon_id;
//                     return (
//                       <div
//                         key={coupon.coupon_id}
//                         className="border rounded-2 p-3 mb-3"
//                         style={{
//                           backgroundColor: isApplied ? "#e8f5e9" : "#fff",
//                         }}
//                       >
//                         <h6 className="fw-bold mb-1">{coupon.coupon_name}</h6>
//                         <p className="text-primary mb-2 small">
//                           {coupon.discount_value}% OFF on orders above ₹
//                           {coupon.min_order_value}
//                         </p>
//                         <div className="d-flex justify-content-end align-items-center gap-2">
//                           <button
//                             onClick={() => handleApplyCoupon(coupon)}
//                             className="border-0 px-3 py-1 rounded-1 text-white small"
//                             style={{
//                               backgroundColor: isApplied ? "#4caf50" : "#24aeb1",
//                               cursor: isApplied ? "default" : "pointer",
//                             }}
//                             disabled={isApplied}
//                           >
//                             {isApplied ? "Applied" : "Apply"}
//                           </button>
//                         </div>
//                       </div>
//                     );
//                   })
//                 )}
//               </div>

//               {/* ORDER SUMMARY */}
//               <div className="border p-4">
//                 <h5 className="mb-3">Order Summary</h5>

//                 {cartItems.length > 0 ? (
//                   cartItems.map((item) => (
//                     <div
//                       key={item.prod_id}
//                       className="d-flex justify-content-between mb-2 small"
//                     >
//                       <span>
//                         {item.Product_name}
//                         {item.size && (
//                           <small className="text-muted"> ({item.size} mm)</small>
//                         )}
//                       </span>
//                       <span>
//                         {item.cart_qty} x ₹{item.current_price}
//                       </span>
//                     </div>
//                   ))
//                 ) : (
//                   <p className="text-muted">No product found</p>
//                 )}

//                 <hr />

//                 <div className="d-flex justify-content-between mb-2">
//                   <span>Subtotal</span>
//                   <span>₹{orderSummary.subtotal}</span>
//                 </div>

//                 <div className="d-flex justify-content-between mb-2">
//                   <span>Shipping</span>
//                   <span>
//                     ₹{shippingEnabled ? orderSummary.shipping : "0.00"}
//                   </span>
//                 </div>

//                 {parseFloat(orderSummary.discount) > 0 && (
//                   <div className="d-flex justify-content-between mb-2 text-success">
//                     <span>Discount</span>
//                     <span>- ₹{orderSummary.discount}</span>
//                   </div>
//                 )}

//                 <hr />

//                 <div className="d-flex justify-content-between fw-bold mb-3">
//                   <span>Total</span>
//                   <span>₹{orderSummary.grandTotal}</span>
//                 </div>

//                 <button
//                   onClick={handlePlaceOrder}
//                   className="bg-col text-white w-100 py-2 border-0 rounded-2 fw-bold"
//                   disabled={!selectedAddress || isPlacingOrder}
//                 >
//                   {isPlacingOrder ? "PLACING ORDER..." : "PLACE ORDER"}
//                 </button>

//                 {!selectedAddress && (
//                   <small className="text-danger d-block mt-2 text-center">
//                     Please select an address
//                   </small>
//                 )}
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default BillingDynamic;



// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { useCart } from "../../../Context/CartContext";
// import { useLocation } from "react-router-dom";

// const BASE_URL = "https://ecom.cyberathon.com";

// // ✅ Helper — strips commas before parseFloat so "1,234.00" parses correctly
// const parsePrice = (val) => parseFloat(String(val || "0").replace(/,/g, "")) || 0;

// function BillingDynamic() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   // ── Buy Now data: from navigate state OR sessionStorage fallback ──
//   let storedProduct = null;
//   try {
//     storedProduct = sessionStorage.getItem("buyNowProduct");
//     storedProduct = storedProduct ? JSON.parse(storedProduct) : null;
//   } catch (e) {
//     storedProduct = null;
//   }

//   const buyNowData = location.state?.product || storedProduct;
//   const isBuyNow   = location.state?.buyNow  || !!buyNowData;

//   const userId    = sessionStorage.getItem("userId");
//   const cartToken = localStorage.getItem("cart_token");

//   /* ================= STATE ================= */
//   const [paymentMode, setPaymentMode]       = useState("Cash");
//   const [alertShown, setAlertShown]         = useState(false);
//   const [cartItems, setCartItems]           = useState([]);
//   const [coupons, setCoupons]               = useState([]);
//   const [appliedCoupon, setAppliedCoupon]   = useState(null);
//   const [isPlacingOrder, setIsPlacingOrder] = useState(false);
//   const { setCartCount }                    = useCart();

//   const [shippingEnabled, setShippingEnabled]               = useState(true);
//   // ✅ KEY FIX: track when shippingEnabled is fetched from backend
//   // fetchCart must NOT run until this is true — otherwise Buy Now shipping is 0
//   const [shippingSettingLoaded, setShippingSettingLoaded]   = useState(false);

//   const [paymentSettings, setPaymentSettings] = useState({ prepaid: false, cod: false });

//   const [orderSummary, setOrderSummary] = useState({
//     subtotal:   "0.00",
//     discount:   "0.00",
//     shipping:   "0.00",
//     grandTotal: "0.00",
//   });

//   const [form, setForm] = useState({
//     first_name: "", last_name: "", email: "", phone: "",
//     company_name: "", address1: "", location: "", city: "",
//     state: "", pin_code: "", address_type: "home", add_information: "",
//   });

//   const [addresses, setAddresses]             = useState([]);
//   const [selectedAddress, setSelectedAddress] = useState(null);
//   const [isNewAddress, setIsNewAddress]       = useState(false);

//   /* ================= SAVE BUY NOW TO SESSION ================= */
//   useEffect(() => {
//     if (location.state?.product) {
//       sessionStorage.setItem("buyNowProduct", JSON.stringify(location.state.product));
//     }
//   }, [location.state]);

//   /* ================= PAYMENT SETTINGS ================= */
//   const fetchPaymentSettings = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/index.php/Api/list_payment_setting`);
//       if (res.data.status === true) {
//         const { prepaid, cod } = res.data.data;
//         setPaymentSettings({ prepaid: prepaid === 1, cod: cod === 1 });
//         const savedMode = localStorage.getItem("payment_mode");
//         if (!savedMode) {
//           if (cod === 1)       { setPaymentMode("Cash");    localStorage.setItem("payment_mode", "Cash"); }
//           else if (prepaid === 1) { setPaymentMode("Prepaid"); localStorage.setItem("payment_mode", "Prepaid"); }
//         }
//       }
//     } catch (err) { console.error("Payment setting error", err); }
//   };

//   useEffect(() => { fetchPaymentSettings(); }, []);
//   useEffect(() => {
//     const savedMode = localStorage.getItem("payment_mode");
//     if (savedMode) setPaymentMode(savedMode);
//   }, []);

//   /* ================= SHIPPING SETTINGS ================= */
//   const fetchShippingSetting = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/index.php/Api/list_shipping_setting`);
//       if (res.data.status === true) {
//         setShippingEnabled(res.data.shipping_enabled === 1);
//       }
//     } catch (error) {
//       console.error("Shipping setting error", error);
//     } finally {
//       // ✅ Always mark loaded (even on error) so fetchCart isn't blocked forever
//       setShippingSettingLoaded(true);
//     }
//   };

//   useEffect(() => { fetchShippingSetting(); }, []);

//   /* ================= CALCULATE SHIPPING ================= */
//   const calculateShipping = async (items) => {
//     try {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/calculate_shipping`, {
//         cart_items: items,
//       });
//       // ✅ backend returns number_format string e.g. "50.00" — parsePrice handles commas too
//       const shipping_total = parsePrice(res.data.shipping_price);

//       setOrderSummary((prev) => ({
//         ...prev,
//         shipping:   shipping_total.toFixed(2),
//         grandTotal: (
//           parsePrice(prev.subtotal) -
//           parsePrice(prev.discount) +
//           shipping_total
//         ).toFixed(2),
//       }));
//     } catch (err) {
//       console.error("Shipping error:", err);
//     }
//   };

//   /* ================= FETCH CART ================= */
//   const fetchCart = async () => {

//     // ── BUY NOW MODE ──
//     if (isBuyNow && buyNowData) {
//       console.log("🟢 Buy Now Data:", buyNowData);

//       const digitalTypes = ["ebook", "coursesection", "video"];
//       const productType  = buyNowData.product_type || "product";
//       const isDigital    = digitalTypes.includes(productType);

//       const item = {
//         prod_id:      Number(buyNowData.prod_id),
//         Product_name: buyNowData.Product_name,
//         // variant_price takes priority (sized products)
//         current_price: Number(buyNowData.variant_price || buyNowData.current_price),
//         cart_qty:     Number(buyNowData.qty),
//         size_id:      buyNowData.size_id ? Number(buyNowData.size_id) : null,
//         size:         buyNowData.size,
//         Product_image: buyNowData.Product_image,
//         product_type: productType,
//         // ✅ Ensure weight is a proper float — critical for shipping slab lookup
//         weight:       parseFloat(buyNowData.weight) || 0,
//       };

//       setCartItems([item]);

//       const subtotal = item.current_price * item.cart_qty;

//       // ✅ Apply any saved coupon to buy-now summary
//       const savedCouponId = localStorage.getItem("applied_coupon_id");
//       let discount = 0;
//       if (savedCouponId && coupons.length > 0) {
//         const coupon = coupons.find(c => Number(c.coupon_id) === Number(savedCouponId));
//         if (coupon && subtotal >= parseFloat(coupon.min_order_value || 0)) {
//           if (coupon.discount_type === "percent") {
//             discount = (subtotal * parseFloat(coupon.discount_value)) / 100;
//             if (coupon.max_discount) discount = Math.min(discount, parseFloat(coupon.max_discount));
//           } else {
//             discount = parseFloat(coupon.discount_value);
//           }
//           discount = Math.min(discount, subtotal);
//           setAppliedCoupon(coupon);
//         }
//       }

//       // Set summary first (calculateShipping will update shipping + grandTotal)
//       setOrderSummary({
//         subtotal:   subtotal.toFixed(2),
//         discount:   discount.toFixed(2),
//         shipping:   "0.00",
//         grandTotal: (subtotal - discount).toFixed(2),
//       });

//       // ✅ KEY FIX: calculateShipping only for physical products with real weight
//       // shippingEnabled is now guaranteed to be the real value (shippingSettingLoaded=true)
//       if (shippingEnabled && !isDigital && item.weight > 0) {
//         calculateShipping([
//           {
//             prod_id:      item.prod_id,
//             weight:       item.weight,
//             qty:          item.cart_qty,
//             product_type: item.product_type,
//           },
//         ]);
//       }

//       return;
//     }

//     // ── NORMAL CART MODE ──
//     if (!userId && !cartToken) return;

//     try {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//         user_id:    userId ? userId : null,
//         cart_token: userId ? null : cartToken,
//       });

//       console.log("🔴 Cart API Response:", res.data);

//       if (res.data.status) {
//         const mappedItems = (res.data.cart_items || []).map((item) => ({
//           ...item,
//           prod_id:       Number(item.prod_id),
//           cart_qty:      Number(item.cart_qty),
//           size_id:       item.size_id ? Number(item.size_id) : null,
//           size:          item.size,
//           current_price: Number(item.current_price),
//           Product_name:  item.Product_name,
//           Product_image: item.Product_image,
//           product_type:  item.product_type || "product",
//           weight:        parseFloat(item.weight) || 0,
//         }));

//         console.log("🔴 Mapped Cart Items:", mappedItems);
//         setCartItems(mappedItems);

//         // ✅ list_cart now returns round() values without commas — safe to parsePrice
//         const subtotal   = parsePrice(res.data.subtotal);
//         const discount   = parsePrice(res.data.discount);
//         const shipping   = shippingEnabled ? parsePrice(res.data.shipping_total) : 0;
//         const grandTotal = subtotal - discount + shipping;

//         // Set summary FIRST, then calculateShipping updates shipping+grandTotal on top
//         setOrderSummary({
//           subtotal:   subtotal.toFixed(2),
//           discount:   discount.toFixed(2),
//           shipping:   shipping.toFixed(2),
//           grandTotal: grandTotal.toFixed(2),
//         });

//         if (shippingEnabled) {
//           calculateShipping(mappedItems);
//         }

//         // Coupon
//         if (res.data.applied_coupon_id) {
//           const coupon = coupons.find(
//             (c) => Number(c.coupon_id) === Number(res.data.applied_coupon_id)
//           );
//           if (coupon) {
//             setAppliedCoupon(coupon);
//             localStorage.setItem("applied_coupon_id", res.data.applied_coupon_id);
//           }
//         } else {
//           setAppliedCoupon(null);
//           localStorage.removeItem("applied_coupon_id");
//         }
//       } else {
//         setCartItems([]);
//       }
//     } catch (err) {
//       console.error("fetchCart error", err);
//     }
//   };

//   /* ================= FETCH COUPONS ================= */
//   const fetchCoupons = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/index.php/Api/list_coupon`);
//       setCoupons(res.data.data || []);
//     } catch (error) { console.error("Coupon API Error:", error); }
//   };

//   useEffect(() => { fetchCoupons(); }, []);

//   // ✅ KEY FIX: shippingSettingLoaded added to condition AND dependency array
//   // fetchCart was firing BEFORE shippingEnabled was set from backend
//   // This caused Buy Now to always call calculateShipping with shippingEnabled=true (default)
//   // but then the real value might be false — or worse, weight=0 path was taken
//   useEffect(() => {
//     if (coupons.length > 0 && shippingSettingLoaded) {
//       fetchCart();
//     }
//   }, [userId, cartToken, coupons, shippingEnabled, isBuyNow, shippingSettingLoaded]);

//   /* ================= LOGIN CHECK ================= */
//   useEffect(() => {
//     if (isBuyNow && buyNowData) return;
//     if (!userId && !alertShown) {
//       alert("Please login to continue");
//       sessionStorage.setItem("redirectAfterLogin", "/Bill");
//       window.dispatchEvent(new Event("openLoginModal"));
//       setAlertShown(true);
//     }
//   }, [userId, alertShown, isBuyNow, buyNowData]);

//   /* ================= FETCH ADDRESSES ================= */
//   const fetchAddresses = async () => {
//     if (!userId) return;
//     try {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/list_billing_address`, { user_id: userId });
//       if (res.data.status) setAddresses(res.data.data || []);
//     } catch (error) { console.error("Fetch addresses error:", error); }
//   };

//   useEffect(() => { fetchAddresses(); }, [userId]);
//   useEffect(() => {
//     if (addresses.length > 0 && !selectedAddress && !isNewAddress) setSelectedAddress(addresses[0]);
//   }, [addresses]);

//   /* ================= AUTO FILL ================= */
//   useEffect(() => {
//     if (!userId) return;
//     setForm((prev) => ({
//       ...prev,
//       first_name: sessionStorage.getItem("first_name") || "",
//       last_name:  sessionStorage.getItem("last_name")  || "",
//       email:      sessionStorage.getItem("email")       || "",
//       phone:      sessionStorage.getItem("phone")       || "",
//     }));
//   }, [userId]);

//   /* ================= HANDLERS ================= */
//   const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

//   const addNewAddressToList = () => {
//     if (!form.first_name || !form.last_name)    { alert("Please enter first name and last name"); return; }
//     if (!/^\d{6}$/.test(form.pin_code))         { alert("Enter valid 6 digit pincode"); return; }
//     if (!/^\d{10}$/.test(form.phone))            { alert("Enter valid 10 digit phone number"); return; }
//     if (!/^\S+@\S+\.\S+$/.test(form.email))     { alert("Enter valid email address"); return; }
//     if (!form.address1 || !form.city || !form.state) { alert("Please fill all required address fields"); return; }

//     setSelectedAddress({ ...form, billing_id: "new", isNew: true });
//     setIsNewAddress(true);
//     alert("New address ready! Click 'PLACE ORDER' to continue.");
//     setForm({
//       first_name: sessionStorage.getItem("first_name") || "",
//       last_name:  sessionStorage.getItem("last_name")  || "",
//       email:      sessionStorage.getItem("email")       || "",
//       phone:      sessionStorage.getItem("phone")       || "",
//       company_name: "", address1: "", location: "", city: "",
//       state: "", pin_code: "", address_type: "home", add_information: "",
//     });
//   };

//   const handleSelectAddress = (addr) => { setSelectedAddress(addr); setIsNewAddress(false); };

//   // const handleApplyCoupon = async (coupon) => {
//   //   try {
//   //     const res = await axios.post(`${BASE_URL}/index.php/Api/apply_coupon`, {
//   //       coupon_id:  coupon.coupon_id,
//   //       user_id:    userId ? userId : null,
//   //       cart_token: userId ? null : cartToken,
//   //     });
//   //     if (res.data.status) {
//   //       setAppliedCoupon(coupon);
//   //       localStorage.setItem("applied_coupon_id", coupon.coupon_id);
//   //       alert(`Coupon applied! You saved ₹${res.data.discount}`);
//   //       await fetchCart();
//   //     } else {
//   //       alert(res.data.message || "Failed to apply coupon");
//   //     }
//   //   } catch (error) { console.error("Apply coupon error:", error); }
//   // };

//   const handleApplyCoupon = async (coupon) => {
//   const subtotal = parsePrice(orderSummary.subtotal);

//   // ── Calculate discount locally (works for both Buy Now and cart mode) ──
//   let discount = 0;
//   if (coupon.discount_type === "percent") {
//     discount = (subtotal * parseFloat(coupon.discount_value)) / 100;
//     if (coupon.max_discount) {
//       discount = Math.min(discount, parseFloat(coupon.max_discount));
//     }
//   } else {
//     discount = parseFloat(coupon.discount_value);
//   }
//   discount = Math.min(discount, subtotal);
//   discount = Math.round(discount * 100) / 100;

//   // ── For Buy Now mode: apply locally, skip API ──
//   if (isBuyNow) {
//     setAppliedCoupon(coupon);
//     localStorage.setItem("applied_coupon_id", coupon.coupon_id);
//     const shipping = parsePrice(orderSummary.shipping);
//     setOrderSummary((prev) => ({
//       ...prev,
//       discount: discount.toFixed(2),
//       grandTotal: (subtotal - discount + shipping).toFixed(2),
//     }));
//     alert(`Coupon applied! You saved ₹${discount.toFixed(2)}`);
//     return;
//   }

//   // ── For cart mode: use API ──
//   try {
//     const res = await axios.post(`${BASE_URL}/index.php/Api/apply_coupon`, {
//       coupon_id:  coupon.coupon_id,
//       user_id:    userId ? userId : null,
//       cart_token: userId ? null : cartToken,
//       subtotal:   subtotal,  // ✅ send subtotal so backend uses correct value
//     });
//     if (res.data.status === true || res.data.status === "true") {
//       setAppliedCoupon(coupon);
//       localStorage.setItem("applied_coupon_id", coupon.coupon_id);
//       alert(`Coupon applied! You saved ₹${discount.toFixed(2)}`);
//       await fetchCart();
//     } else {
//       alert(res.data.message || "Failed to apply coupon");
//     }
//   } catch (error) {
//     console.error("Apply coupon error:", error);
//   }
// };
//   /* ================= PLACE ORDER ================= */
//   const handlePlaceOrder = async () => {
//     console.log("🔴 ========== PLACE ORDER START ==========");
//     if (isPlacingOrder) return;
//     if (!selectedAddress) { alert("Please select or add a delivery address"); return; }
//     if (!cartItems || cartItems.length === 0) { alert("Your cart is empty. Please add items first."); navigate("/"); return; }
//     if (cartItems.filter(i => !i.prod_id).length > 0) { alert("Cart items are invalid. Please refresh and try again."); return; }

//     setIsPlacingOrder(true);

//     try {
//       // ✅ Always send price — backend priority: price > subtotal > DB fallback
//       const cartItemsPayload = buyNowData
//         ? [{
//             prod_id: Number(buyNowData.prod_id),
//             size_id: buyNowData.size_id ? Number(buyNowData.size_id) : null,
//             qty:     Number(buyNowData.qty),
//             price:   Number(buyNowData.variant_price || buyNowData.current_price),
//           }]
//         : cartItems.map((item) => ({
//             prod_id: Number(item.prod_id),
//             size_id: item.size_id ? Number(item.size_id) : null,
//             qty:     Number(item.cart_qty),
//             price:   Number(item.current_price),
//           }));

//       let payload = {
//         user_id:        userId ? Number(userId) : null,
//         cart_token:     userId ? null : cartToken,
//         cart_items:     cartItemsPayload,
//         payment_mode:   paymentMode,
//         shipping_total: shippingEnabled ? parsePrice(orderSummary.shipping) : 0,
//       };

//       if (!isNewAddress && selectedAddress) {
//         payload = {
//           ...payload,
//           billing_id:      Number(selectedAddress.billing_id),
//           first_name:      selectedAddress.first_name,
//           last_name:       selectedAddress.last_name,
//           email:           selectedAddress.email,
//           phone:           selectedAddress.phone,
//           company_name:    selectedAddress.company_name    || "",
//           address1:        selectedAddress.address1,
//           location:        selectedAddress.location        || "",
//           city:            selectedAddress.city,
//           state:           selectedAddress.state,
//           pin_code:        selectedAddress.pin_code,
//           address_type:    selectedAddress.address_type,
//           add_information: selectedAddress.add_information || "",
//           country:         "India",
//         };
//       }

//       if (isNewAddress && selectedAddress?.isNew) {
//         payload = {
//           ...payload,
//           first_name:      selectedAddress.first_name,
//           last_name:       selectedAddress.last_name,
//           email:           selectedAddress.email,
//           phone:           selectedAddress.phone,
//           company_name:    selectedAddress.company_name    || "",
//           address1:        selectedAddress.address1,
//           location:        selectedAddress.location        || "",
//           city:            selectedAddress.city,
//           state:           selectedAddress.state,
//           pin_code:        selectedAddress.pin_code,
//           address_type:    selectedAddress.address_type,
//           add_information: selectedAddress.add_information || "",
//           country:         "India",
//         };
//       }

//       const appliedCouponId = localStorage.getItem("applied_coupon_id");
//       if (appliedCouponId) payload.coupon_id = Number(appliedCouponId);

//       console.log("🔴 FINAL PAYLOAD:", JSON.stringify(payload, null, 2));

//       const res = await axios.post(`${BASE_URL}/index.php/Api/place_order`, payload);
//       console.log("🔴 API RESPONSE:", res.data);

//       if (res.data.status === true || res.data.success === "1") {
//         sessionStorage.removeItem("buyNowProduct");
//         alert("Order placed successfully!");
//         localStorage.removeItem("applied_coupon_id");
//         localStorage.removeItem("cart_token");
//         setCartCount(0);
//         await fetchAddresses();
//         navigate("/order-confirm", { state: { orderId: res.data.order_id, billingId: res.data.billing_id } });
//       } else {
//         alert(res.data.message || "Failed to place order");
//         setIsPlacingOrder(false);
//       }
//     } catch (error) {
//       console.error(error);
//       alert(`Error: ${error.response?.data?.message || error.message}`);
//       setIsPlacingOrder(false);
//     }
//   };

//   /* ================= COUPON FILTERING ================= */
//   const currentTotal = parsePrice(orderSummary.subtotal);
//   const today = new Date();
//   today.setHours(0, 0, 0, 0);

//   const eligibleCoupons = coupons.filter((coupon) => {
//     const minVal        = parsePrice(coupon.min_order_value);
//     const couponEndDate = new Date(coupon.end_date);
//     couponEndDate.setHours(23, 59, 59, 999);
//     return coupon.status === "active" && currentTotal >= minVal && today <= couponEndDate;
//   });

//   /* ================= RENDER ================= */
//   return (
//     <div className="container my-5">
//       <h4 className="fw-bold mb-4">BILLING DETAILS</h4>
//       <div className="row g-4">

//         {/* LEFT */}
//         <div className="col-md-8">
//           <div className="border p-4 rounded-2">
//             <h6 className="fw-bold mb-3">Billing Information</h6>
//             <div className="row g-md-4 g-3 mb-3">
//               <div className="col-md-6"><input name="first_name" value={form.first_name} onChange={handleChange} className="form-control" placeholder="First Name *" /></div>
//               <div className="col-md-6"><input name="last_name"  value={form.last_name}  onChange={handleChange} className="form-control" placeholder="Last Name *" /></div>
//             </div>
//             <div className="row mb-3 g-md-4 g-3">
//               <div className="col-md-6"><input name="email" value={form.email} onChange={handleChange} className="form-control" placeholder="Email *" /></div>
//               <div className="col-md-6"><input name="phone" value={form.phone} onChange={handleChange} className="form-control" placeholder="Phone *" /></div>
//             </div>
//             <input name="company_name" value={form.company_name} onChange={handleChange} className="form-control mb-3" placeholder="Company Name (Optional)" />

//             <h6 className="fw-bold mb-3">ADDRESS</h6>
//             <input name="pin_code"  value={form.pin_code}  onChange={handleChange} className="form-control mb-2" placeholder="Pin Code *" />
//             <input name="address1"  value={form.address1}  onChange={handleChange} className="form-control mb-2" placeholder="Address *" />
//             <input name="location"  value={form.location}  onChange={handleChange} className="form-control mb-2" placeholder="Location" />
//             <div className="row mb-3 g-md-4 g-2">
//               <div className="col-md-6"><input name="city"  value={form.city}  onChange={handleChange} className="form-control" placeholder="City *" /></div>
//               <div className="col-md-6"><input name="state" value={form.state} onChange={handleChange} className="form-control" placeholder="State *" /></div>
//             </div>
//             <textarea name="add_information" value={form.add_information} onChange={handleChange} className="form-control mb-3" placeholder="Additional Information" rows="2" />

//             <strong>ADDRESS TYPE</strong>
//             <div className="mb-3">
//               <label className="me-3"><input type="radio" checked={form.address_type === "home"}   onChange={() => setForm({ ...form, address_type: "home" })}   /> Home</label>
//               <label>               <input type="radio" checked={form.address_type === "office"} onChange={() => setForm({ ...form, address_type: "office" })} /> Office</label>
//             </div>

//             <button onClick={addNewAddressToList} className="bg-col text-white w-100 py-2 border-0 rounded-2 fw-bold mb-4">ADD NEW ADDRESS</button>

//             {userId && (
//               <>
//                 <h6 className="fw-bold mb-3">{isNewAddress && selectedAddress?.isNew ? "NEW ADDRESS (Will be saved)" : "DELIVERY ADDRESS"}</h6>

//                 {isNewAddress && selectedAddress?.isNew && (
//                   <div className="border rounded-2 p-3 mb-3 bg-light">
//                     <label className="d-flex gap-2 w-100">
//                       <input type="radio" name="selectAddress" checked readOnly />
//                       <div>
//                         <p className="mb-1 fw-semibold">{selectedAddress.first_name} {selectedAddress.last_name}<span className="badge bg-success ms-2 small">NEW</span></p>
//                         <p className="mb-1">{selectedAddress.address1}</p>
//                         <small>{selectedAddress.city}, {selectedAddress.state} - {selectedAddress.pin_code}</small>
//                       </div>
//                     </label>
//                   </div>
//                 )}

//                 {addresses.length === 0 && !isNewAddress && <p className="text-muted">No saved addresses.</p>}

//                 {addresses.map((addr) => (
//                   <div key={addr.billing_id} className={`border rounded-2 p-3 mb-3 ${!isNewAddress && selectedAddress?.billing_id === addr.billing_id ? "border-primary bg-light" : ""}`}>
//                     <div className="d-flex justify-content-between">
//                       <label className="d-flex gap-2 w-100">
//                         <input type="radio" name="selectAddress" checked={!isNewAddress && selectedAddress?.billing_id === addr.billing_id} onChange={() => handleSelectAddress(addr)} />
//                         <div>
//                           <p className="mb-1 fw-semibold">{addr.first_name} {addr.last_name}</p>
//                           <p className="mb-1">{addr.address1}</p>
//                           <small>{addr.city}, {addr.state} - {addr.pin_code}</small>
//                         </div>
//                       </label>
//                       <button onClick={() => handleSelectAddress(addr)} className="bg-col text-white border-0 px-3 py-1 rounded-2">DELIVER HERE</button>
//                     </div>
//                   </div>
//                 ))}
//               </>
//             )}
//           </div>
//         </div>

//         {/* RIGHT */}
//         <div className="col-md-4">
//           <h5 className="fw-bold mb-3">Payment Mode</h5>

//           <div className={`p-3 border ${!paymentSettings.cod ? "opacity-50" : ""}`}>
//             <label className="d-flex align-items-center">
//               <input type="radio" disabled={!paymentSettings.cod} checked={paymentMode === "Cash"} onChange={() => { setPaymentMode("Cash"); localStorage.setItem("payment_mode", "Cash"); }} className="me-2" />
//               Cash On Delivery
//               {!paymentSettings.cod && <small className="text-danger ms-2">(Disabled by Admin)</small>}
//             </label>
//           </div>
//           <div className={`p-3 border ${!paymentSettings.prepaid ? "opacity-50" : ""}`}>
//             <label className="d-flex align-items-center">
//               <input type="radio" disabled={!paymentSettings.prepaid} checked={paymentMode === "Prepaid"} onChange={() => { setPaymentMode("Prepaid"); localStorage.setItem("payment_mode", "Prepaid"); }} className="me-2" />
//               Prepaid (Online Payment)
//             </label>
//           </div>

//           {userId && (
//             <>
//               <div className="border p-4 shadow-sm mt-3 mb-4">
//                 <div className="d-flex justify-content-between align-items-center mb-3">
//                   <h5 className="mb-0">Available Coupons</h5>
//                   <button onClick={() => navigate("/coupon")} className="btn btn-sm btn-link text-decoration-none">Show All</button>
//                 </div>

//                 {/* {appliedCoupon && (
//                   <div className="alert alert-success py-2 px-3 mb-3">
//                     <small>✓ Coupon <strong>{appliedCoupon.code}</strong> applied</small>
//                   </div>
//                 )} */}
// {appliedCoupon && (
//   <div className="alert alert-success py-2 px-3 mb-3 d-flex justify-content-between align-items-center">
//     <small>✓ Coupon <strong>{appliedCoupon.code}</strong> applied — saved ₹{orderSummary.discount}</small>
//     <button
//       className="btn btn-sm btn-link text-danger p-0 ms-2"
//       onClick={() => {
//         setAppliedCoupon(null);
//         localStorage.removeItem("applied_coupon_id");
//         fetchCart(); // recalculate without coupon
//       }}
//     >
//       Remove
//     </button>
//   </div>
// )}
//                 {eligibleCoupons.length === 0 ? (
//                   <p className="text-muted small">No eligible coupons for your order. <span onClick={() => navigate("/coupon")} style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}>View all coupons</span></p>
//                 ) : (
//                   eligibleCoupons.map((coupon) => {
//                     const isApplied = appliedCoupon?.coupon_id === coupon.coupon_id;
//                     return (
//                       <div key={coupon.coupon_id} className="border rounded-2 p-3 mb-3" style={{ backgroundColor: isApplied ? "#e8f5e9" : "#fff" }}>
//                         <h6 className="fw-bold mb-1">{coupon.coupon_name}</h6>
//                         {/* <p className="text-primary mb-2 small">{coupon.discount_value}% OFF on orders above ₹{coupon.min_order_value}</p> */}
//                         <p className="text-primary mb-2 small">
//   {coupon.discount_type === "percent"
//     ? `${coupon.discount_value}% OFF (max ₹${coupon.max_discount}) on orders above ₹${coupon.min_order_value}`
//     : `₹${coupon.discount_value} OFF on orders above ₹${coupon.min_order_value}`
//   }
// </p>
//                         <div className="d-flex justify-content-end">
//                           <button onClick={() => handleApplyCoupon(coupon)} className="border-0 px-3 py-1 rounded-1 text-white small" style={{ backgroundColor: isApplied ? "#4caf50" : "#24aeb1", cursor: isApplied ? "default" : "pointer" }} disabled={isApplied}>
//                             {isApplied ? "Applied" : "Apply"}
//                           </button>
//                         </div>
//                       </div>
//                     );
//                   })
//                 )}
//               </div>

//               <div className="border p-4">
//                 <h5 className="mb-3">Order Summary</h5>

//                 {cartItems.length > 0 ? (
//                   cartItems.map((item) => (
//                     <div key={item.prod_id} className="d-flex justify-content-between mb-2 small">
//                       <span>{item.Product_name}{item.size && <small className="text-muted"> ({item.size} mm)</small>}</span>
//                       <span>{item.cart_qty} x ₹{item.current_price}</span>
//                     </div>
//                   ))
//                 ) : <p className="text-muted">No product found</p>}

//                 <hr />
//                 <div className="d-flex justify-content-between mb-2"><span>Subtotal</span><span>₹{orderSummary.subtotal}</span></div>
//                 <div className="d-flex justify-content-between mb-2"><span>Shipping</span><span>₹{shippingEnabled ? orderSummary.shipping : "0.00"}</span></div>
//                 {parsePrice(orderSummary.discount) > 0 && (
//                   <div className="d-flex justify-content-between mb-2 text-success"><span>Discount</span><span>- ₹{orderSummary.discount}</span></div>
//                 )}
//                 <hr />
//                 <div className="d-flex justify-content-between fw-bold mb-3"><span>Total</span><span>₹{orderSummary.grandTotal}</span></div>

//                 <button onClick={handlePlaceOrder} className="bg-col text-white w-100 py-2 border-0 rounded-2 fw-bold" disabled={!selectedAddress || isPlacingOrder}>
//                   {isPlacingOrder ? "PLACING ORDER..." : "PLACE ORDER"}
//                 </button>
//                 {!selectedAddress && <small className="text-danger d-block mt-2 text-center">Please select an address</small>}
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default BillingDynamic;






import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../../Context/CartContext";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://ecom.cyberathon.com";

const RAZORPAY_KEY_ID = "rzp_live_T2Z5RWqkbP1fn4";

// ✅ Helper — strips commas before parseFloat so "1,234.00" parses correctly
const parsePrice = (val) => parseFloat(String(val || "0").replace(/,/g, "")) || 0;

function BillingDynamic() {
  const navigate = useNavigate();
  const location = useLocation();

  // ── Buy Now data: from navigate state OR sessionStorage fallback ──
  let storedProduct = null;
  try {
    storedProduct = sessionStorage.getItem("buyNowProduct");
    storedProduct = storedProduct ? JSON.parse(storedProduct) : null;
  } catch (e) {
    storedProduct = null;
  }

  const buyNowData = location.state?.product || storedProduct;
  const isBuyNow   = location.state?.buyNow  || !!buyNowData;

  const userId    = sessionStorage.getItem("userId");
  const cartToken = localStorage.getItem("cart_token");

  /* ================= STATE ================= */
  const [paymentMode, setPaymentMode]       = useState("Cash");
  const [alertShown, setAlertShown]         = useState(false);
  const [cartItems, setCartItems]           = useState([]);
  const [coupons, setCoupons]               = useState([]);
  const [appliedCoupon, setAppliedCoupon]   = useState(null);
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);
  const { setCartCount }                    = useCart();

  const [shippingEnabled, setShippingEnabled]             = useState(true);
  const [shippingSettingLoaded, setShippingSettingLoaded] = useState(false);

  const [paymentSettings, setPaymentSettings] = useState({ prepaid: false, cod: false });

  const [orderSummary, setOrderSummary] = useState({
    subtotal:   "0.00",
    discount:   "0.00",
    shipping:   "0.00",
    grandTotal: "0.00",
  });

  const [form, setForm] = useState({
    first_name: "", last_name: "", email: "", phone: "",
    company_name: "", address1: "", location: "", city: "",
    state: "", pin_code: "", address_type: "home", add_information: "",
  });

  const [addresses, setAddresses]             = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [isNewAddress, setIsNewAddress]       = useState(false);

  /* ================= SAVE BUY NOW TO SESSION ================= */
  useEffect(() => {
    if (location.state?.product) {
      sessionStorage.setItem("buyNowProduct", JSON.stringify(location.state.product));
    }
  }, [location.state]);

  useEffect(() => {
  if (!location.state?.product && !storedProduct) {
    // No buy now data → reset
    if (isBuyNow) {
      setCartItems([]);
      setOrderSummary({
        subtotal: "0.00",
        discount: "0.00",
        shipping: "0.00",
        grandTotal: "0.00",
      });
    }
  }
}, []);
  /* ================= PAYMENT SETTINGS ================= */
  const fetchPaymentSettings = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/index.php/Api/list_payment_setting`);
      if (res.data.status === true) {
        const { prepaid, cod } = res.data.data;
        setPaymentSettings({ prepaid: prepaid === 1, cod: cod === 1 });
        const savedMode = localStorage.getItem("payment_mode");
        if (!savedMode) {
          if (cod === 1)          { setPaymentMode("Cash");    localStorage.setItem("payment_mode", "Cash"); }
          else if (prepaid === 1) { setPaymentMode("Prepaid"); localStorage.setItem("payment_mode", "Prepaid"); }
        }
      }
    } catch (err) { console.error("Payment setting error", err); }
  };

  useEffect(() => { fetchPaymentSettings(); }, []);
  useEffect(() => {
    const savedMode = localStorage.getItem("payment_mode");
    if (savedMode) setPaymentMode(savedMode);
  }, []);

  /* ================= SHIPPING SETTINGS ================= */
  const fetchShippingSetting = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/index.php/Api/list_shipping_setting`);
      if (res.data.status === true) {
        setShippingEnabled(res.data.shipping_enabled === 1);
      }
    } catch (error) {
      console.error("Shipping setting error", error);
    } finally {
      setShippingSettingLoaded(true);
    }
  };

  useEffect(() => { fetchShippingSetting(); }, []);

  /* ================= CALCULATE SHIPPING ================= */
  const calculateShipping = async (items) => {
    try {
      const res = await axios.post(`${BASE_URL}/index.php/Api/calculate_shipping`, {
        cart_items: items,
      });
      const shipping_total = parsePrice(res.data.shipping_price);

      setOrderSummary((prev) => ({
        ...prev,
        shipping:   shipping_total.toFixed(2),
        grandTotal: (
          parsePrice(prev.subtotal) -
          parsePrice(prev.discount) +
          shipping_total
        ).toFixed(2),
      }));
    } catch (err) {
      console.error("Shipping error:", err);
    }
  };

  /* ================= FETCH CART ================= */
  const fetchCart = async () => {

    // ── BUY NOW MODE ──
    if (isBuyNow && buyNowData) {
      console.log("🟢 Buy Now Data:", buyNowData);

      const digitalTypes = ["ebook", "coursesection", "video"];
      const productType  = buyNowData.product_type || "product";
      const isDigital    = digitalTypes.includes(productType);

      // discount add karne ke phele wala code Nikita code
      // const item = {
      //   prod_id:       Number(buyNowData.prod_id),
      //   Product_name:  buyNowData.Product_name,
      //   current_price: Number(buyNowData.variant_price || buyNowData.current_price),
      //   cart_qty:      Number(buyNowData.qty),
      //   size_id:       buyNowData.size_id ? Number(buyNowData.size_id) : null,
      //   size:          buyNowData.size,
      //   Product_image: buyNowData.Product_image,
      //   product_type:  productType,
      //   weight:        parseFloat(buyNowData.weight) || 0,
      // };

      // setCartItems([item]);
      // const subtotal = item.current_price * item.cart_qty;


      // 02-07-2026 clinet ne discount add karne ko bola uske bad wala code 
      const item = {
  prod_id:       Number(buyNowData.prod_id),
  Product_name:  buyNowData.Product_name,
  current_price: Number(buyNowData.variant_price || buyNowData.current_price),
  old_price:     Number(buyNowData.old_price) || 0,
  discount:      Number(buyNowData.discount) || 0,
  cart_qty:      Number(buyNowData.qty),
  size_id:       buyNowData.size_id ? Number(buyNowData.size_id) : null,
  size:          buyNowData.size,
  Product_image: buyNowData.Product_image,
  product_type:  productType,
  weight:        parseFloat(buyNowData.weight) || 0,
};

setCartItems([item]);

const subtotal = item.current_price * item.cart_qty;
// const productDiscount = item.discount * item.cart_qty;


const productDiscount =
  (item.current_price * item.cart_qty * (item.discount || 0)) / 100;






    // Discount dalne ke phele wala code Nikita
      // ✅ Apply any saved coupon to buy-now summary
      // const savedCouponId = localStorage.getItem("applied_coupon_id");
      // let discount = 0;
      // if (savedCouponId && coupons.length > 0) {
      //   const coupon = coupons.find(c => Number(c.coupon_id) === Number(savedCouponId));
      //   if (coupon && subtotal >= parseFloat(coupon.min_order_value || 0)) {
      //     if (coupon.discount_type === "percent") {
      //       discount = (subtotal * parseFloat(coupon.discount_value)) / 100;
      //       if (coupon.max_discount) discount = Math.min(discount, parseFloat(coupon.max_discount));
      //     } else {
      //       discount = parseFloat(coupon.discount_value);
      //     }
      //     discount = Math.min(discount, subtotal);
      //     discount = Math.round(discount * 100) / 100;
      //     setAppliedCoupon(coupon);
      //   }
      // }


      // discount add karne ke pheel wala code Nikita
      // Set summary first — calculateShipping will update shipping + grandTotal on top
      // setOrderSummary({
      //   subtotal:   subtotal.toFixed(2),
      //   discount:   discount.toFixed(2),
      //   shipping:   "0.00",
      //   grandTotal: (subtotal - discount).toFixed(2),
      // });




      // 02-07-2026 client ne discount add karne ko bola wala code

      // ✅ Apply any saved coupon to buy-now summary
const savedCouponId = localStorage.getItem("applied_coupon_id");
let couponDiscount = 0;
if (savedCouponId && coupons.length > 0) {
  const coupon = coupons.find(c => Number(c.coupon_id) === Number(savedCouponId));
  if (coupon && subtotal >= parseFloat(coupon.min_order_value || 0)) {
    if (coupon.discount_type === "percent") {
      couponDiscount = (subtotal * parseFloat(coupon.discount_value)) / 100;
      if (coupon.max_discount) couponDiscount = Math.min(couponDiscount, parseFloat(coupon.max_discount));
    } else {
      couponDiscount = parseFloat(coupon.discount_value);
    }
    couponDiscount = Math.min(couponDiscount, subtotal);
    couponDiscount = Math.round(couponDiscount * 100) / 100;
    setAppliedCoupon(coupon);
  }
}

// ✅ Product discount + Coupon discount combined
const totalDiscount = productDiscount + couponDiscount;

// Set summary first — calculateShipping will update shipping + grandTotal on top
setOrderSummary({
  subtotal:   subtotal.toFixed(2),
  discount:   totalDiscount.toFixed(2),
  shipping:   "0.00",
  grandTotal: (subtotal - totalDiscount).toFixed(2),
});




      // Only calculate shipping for physical products with weight
      if (shippingEnabled && !isDigital && item.weight > 0) {
        calculateShipping([{
          prod_id:      item.prod_id,
          weight:       item.weight,
          qty:          item.cart_qty,
          product_type: item.product_type,
        }]);
      }

      return;
    }

    // ── NORMAL CART MODE ──
    if (!userId && !cartToken) return;

    try {
      const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
        user_id:    userId ? userId : null,
        cart_token: userId ? null   : cartToken,
      });

      console.log("🔴 Cart API Response:", res.data);

      if (res.data.status) {
        const mappedItems = (res.data.cart_items || []).map((item) => ({
          ...item,
          prod_id:       Number(item.prod_id),
          cart_qty:      Number(item.cart_qty),
          size_id:       item.size_id ? Number(item.size_id) : null,
          size:          item.size || null,
          current_price: Number(item.current_price),
          Product_name:  item.Product_name,
          Product_image: item.Product_image,
          product_type:  item.product_type || "product",
          weight:        parseFloat(item.weight) || 0,
        }));

        setCartItems(mappedItems);

        const subtotal   = parsePrice(res.data.subtotal);
        const discount   = parsePrice(res.data.discount);
        const shipping   = shippingEnabled ? parsePrice(res.data.shipping_total) : 0;
        const grandTotal = subtotal - discount + shipping;

        // ✅ Set summary from API first — no coupon re-application here
        // discount from list_cart is already correct (backend calculates from coupon_id in cart)
        setOrderSummary({
          subtotal:   subtotal.toFixed(2),
          discount:   discount.toFixed(2),
          shipping:   shipping.toFixed(2),
          grandTotal: grandTotal.toFixed(2),
        });

        // calculateShipping updates shipping+grandTotal using prev.discount correctly
        if (shippingEnabled) {
          calculateShipping(mappedItems);
        }

        // Sync applied coupon state from cart
        if (res.data.applied_coupon_id) {
          const coupon = coupons.find(
            (c) => Number(c.coupon_id) === Number(res.data.applied_coupon_id)
          );
          if (coupon) {
            setAppliedCoupon(coupon);
            localStorage.setItem("applied_coupon_id", res.data.applied_coupon_id);
          }
        } else {
          setAppliedCoupon(null);
          localStorage.removeItem("applied_coupon_id");
        }
      } else {
        setCartItems([]);
      }
    } catch (err) {
      console.error("fetchCart error", err);
    }
  };

  /* ================= FETCH COUPONS ================= */
  const fetchCoupons = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/index.php/Api/list_coupon`);
      setCoupons(res.data.data || []);
    } catch (error) { console.error("Coupon API Error:", error); }
  };

  useEffect(() => { fetchCoupons(); }, []);

  useEffect(() => {
    if (coupons.length > 0 && shippingSettingLoaded) {
      fetchCart();
    }
  }, [userId, cartToken, coupons, shippingEnabled, isBuyNow, shippingSettingLoaded]);

  /* ================= LOGIN CHECK ================= */
  useEffect(() => {
    if (isBuyNow && buyNowData) return;
    if (!userId && !alertShown) {
      alert("Please login to continue");
      sessionStorage.setItem("redirectAfterLogin", "/Bill");
      window.dispatchEvent(new Event("openLoginModal"));
      setAlertShown(true);
    }
  }, [userId, alertShown, isBuyNow, buyNowData]);

  /* ================= FETCH ADDRESSES ================= */
  const fetchAddresses = async () => {
    if (!userId) return;
    try {
      const res = await axios.post(`${BASE_URL}/index.php/Api/list_billing_address`, { user_id: userId });
      if (res.data.status) setAddresses(res.data.data || []);
    } catch (error) { console.error("Fetch addresses error:", error); }
  };

  useEffect(() => { fetchAddresses(); }, [userId]);
  useEffect(() => {
    if (addresses.length > 0 && !selectedAddress && !isNewAddress) setSelectedAddress(addresses[0]);
  }, [addresses]);

  /* ================= AUTO FILL ================= */
  useEffect(() => {
    if (!userId) return;
    setForm((prev) => ({
      ...prev,
      first_name: sessionStorage.getItem("first_name") || "",
      last_name:  sessionStorage.getItem("last_name")  || "",
      email:      sessionStorage.getItem("email")       || "",
      phone:      sessionStorage.getItem("phone")       || "",
    }));
  }, [userId]);

  /* ================= HANDLERS ================= */
  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const addNewAddressToList = () => {
    if (!form.first_name || !form.last_name)         { alert("Please enter first name and last name"); return; }
    if (!/^\d{6}$/.test(form.pin_code))              { alert("Enter valid 6 digit pincode"); return; }
    if (!/^\d{10}$/.test(form.phone))                { alert("Enter valid 10 digit phone number"); return; }
    // if (!/^\S+@\S+\.\S+$/.test(form.email))         { alert("Enter valid email address"); return; }
    // ✅ Email optional — sirf tab check karo jab user ne kuch likha ho
    if (form.email && form.email.trim() !== "" && !/^\S+@\S+\.\S+$/.test(form.email)) {
      alert("Enter a valid email address");
      return;
    }
    if (!form.address1 || !form.city || !form.state) { alert("Please fill all required address fields"); return; }

    setSelectedAddress({ ...form, billing_id: "new", isNew: true });
    setIsNewAddress(true);
    alert("New address ready! Click 'PLACE ORDER' to continue.");
    setForm({
      first_name:   sessionStorage.getItem("first_name") || "",
      last_name:    sessionStorage.getItem("last_name")  || "",
      email:        sessionStorage.getItem("email")       || "",
      phone:        sessionStorage.getItem("phone")       || "",
      company_name: "", address1: "", location: "", city: "",
      state: "", pin_code: "", address_type: "home", add_information: "",
    });
  };

  const handleSelectAddress = (addr) => { setSelectedAddress(addr); setIsNewAddress(false); };

  /* ================= APPLY COUPON ================= */
  // ✅ KEY FIX: calculate discount LOCALLY for both Buy Now and cart mode
  // For cart mode we still call apply_coupon API to save coupon_id in DB
  // but we do NOT call fetchCart() afterwards — that was causing double discount
  const handleApplyCoupon = async (coupon) => {
    const subtotal = parsePrice(orderSummary.subtotal);

    // ── Calculate discount locally ──
    let discount = 0;
    if (coupon.discount_type === "percent") {
      discount = (subtotal * parseFloat(coupon.discount_value)) / 100;
      if (coupon.max_discount) {
        discount = Math.min(discount, parseFloat(coupon.max_discount));
      }
    } else {
      // fixed discount
      discount = parseFloat(coupon.discount_value);
    }
    discount = Math.min(discount, subtotal);
    discount = Math.round(discount * 100) / 100;

    const shipping      = parsePrice(orderSummary.shipping);
    const newGrandTotal = subtotal - discount + shipping;

    // ── Buy Now mode: no cart in DB, apply locally only ──
    if (isBuyNow) {
      setAppliedCoupon(coupon);
      localStorage.setItem("applied_coupon_id", coupon.coupon_id);
      setOrderSummary((prev) => ({
        ...prev,
        discount:   discount.toFixed(2),
        grandTotal: newGrandTotal.toFixed(2),
      }));
      alert(`Coupon applied! You saved ₹${discount.toFixed(2)}`);
      return;
    }

    // ── Cart mode: save coupon_id to DB, then apply locally ──
    // ✅ DO NOT call fetchCart() — it causes discount to be applied twice
    // list_cart returns discount from DB coupon, then calculateShipping adds it again
    try {
      const res = await axios.post(`${BASE_URL}/index.php/Api/apply_coupon`, {
        coupon_id:  coupon.coupon_id,
        user_id:    userId ? userId : null,
        cart_token: userId ? null   : cartToken,
        subtotal:   subtotal,
      });
      if (res.data.status === true || res.data.status === "true") {
        setAppliedCoupon(coupon);
        localStorage.setItem("applied_coupon_id", coupon.coupon_id);
        // ✅ Apply locally — same calculation as Buy Now, no fetchCart()
        setOrderSummary((prev) => ({
          ...prev,
          discount:   discount.toFixed(2),
          grandTotal: newGrandTotal.toFixed(2),
        }));
        alert(`Coupon applied! You saved ₹${discount.toFixed(2)}`);
      } else {
        alert(res.data.message || "Failed to apply coupon");
      }
    } catch (error) {
      console.error("Apply coupon error:", error);
    }
  };

  /* ================= REMOVE COUPON ================= */
  const handleRemoveCoupon = () => {
    setAppliedCoupon(null);
    localStorage.removeItem("applied_coupon_id");
    // Recalculate grand total without discount
    setOrderSummary((prev) => {
      const sub  = parsePrice(prev.subtotal);
      const ship = parsePrice(prev.shipping);
      return {
        ...prev,
        discount:   "0.00",
        grandTotal: (sub + ship).toFixed(2),
      };
    });
  };

  /* ================= PLACE ORDER ================= */
  // const handlePlaceOrder = async () => {
  //   console.log("🔴 ========== PLACE ORDER START ==========");
  //   if (isPlacingOrder) return;
  //   if (!selectedAddress)                             { alert("Please select or add a delivery address"); return; }
  //   if (!cartItems || cartItems.length === 0)         { alert("Your cart is empty. Please add items first."); navigate("/"); return; }
  //   if (cartItems.filter(i => !i.prod_id).length > 0) { alert("Cart items are invalid. Please refresh and try again."); return; }

  //   setIsPlacingOrder(true);

  //   try {
  //     const cartItemsPayload = buyNowData
  //       ? [{
  //           prod_id: Number(buyNowData.prod_id),
  //           size_id: buyNowData.size_id ? Number(buyNowData.size_id) : null,
  //           qty:     Number(buyNowData.qty),
  //           price:   Number(buyNowData.variant_price || buyNowData.current_price),
  //         }]
  //       : cartItems.map((item) => ({
  //           prod_id: Number(item.prod_id),
  //           size_id: item.size_id ? Number(item.size_id) : null,
  //           qty:     Number(item.cart_qty),
  //           price:   Number(item.current_price),
  //         }));

  //     let payload = {
  //       user_id:        userId ? Number(userId) : null,
  //       cart_token:     userId ? null           : cartToken,
  //       cart_items:     cartItemsPayload,
  //       payment_mode:   paymentMode,
  //       shipping_total: shippingEnabled ? parsePrice(orderSummary.shipping) : 0,
  //     };

  //     if (!isNewAddress && selectedAddress) {
  //       payload = {
  //         ...payload,
  //         billing_id:      Number(selectedAddress.billing_id),
  //         first_name:      selectedAddress.first_name,
  //         last_name:       selectedAddress.last_name,
  //         email:           selectedAddress.email,
  //         phone:           selectedAddress.phone,
  //         company_name:    selectedAddress.company_name    || "",
  //         address1:        selectedAddress.address1,
  //         location:        selectedAddress.location        || "",
  //         city:            selectedAddress.city,
  //         state:           selectedAddress.state,
  //         pin_code:        selectedAddress.pin_code,
  //         address_type:    selectedAddress.address_type,
  //         add_information: selectedAddress.add_information || "",
  //         country:         "India",
  //       };
  //     }

  //     if (isNewAddress && selectedAddress?.isNew) {
  //       payload = {
  //         ...payload,
  //         first_name:      selectedAddress.first_name,
  //         last_name:       selectedAddress.last_name,
  //         email:           selectedAddress.email,
  //         phone:           selectedAddress.phone,
  //         company_name:    selectedAddress.company_name    || "",
  //         address1:        selectedAddress.address1,
  //         location:        selectedAddress.location        || "",
  //         city:            selectedAddress.city,
  //         state:           selectedAddress.state,
  //         pin_code:        selectedAddress.pin_code,
  //         address_type:    selectedAddress.address_type,
  //         add_information: selectedAddress.add_information || "",
  //         country:         "India",
  //       };
  //     }

  //     const appliedCouponId = localStorage.getItem("applied_coupon_id");
  //     if (appliedCouponId) payload.coupon_id = Number(appliedCouponId);

  //     console.log("🔴 FINAL PAYLOAD:", JSON.stringify(payload, null, 2));

  //     const res = await axios.post(`${BASE_URL}/index.php/Api/place_order`, payload);
  //     console.log("🔴 API RESPONSE:", res.data);

  //     if (res.data.status === true || res.data.success === "1") {
  //       sessionStorage.removeItem("buyNowProduct");

  //       // 🔥 ADD HERE
  // setCartItems([]);
  // setOrderSummary({
  //   subtotal: "0.00",
  //   discount: "0.00",
  //   shipping: "0.00",
  //   grandTotal: "0.00",
  // });

  //       alert("Order placed successfully!");
  //       localStorage.removeItem("applied_coupon_id");
  //       localStorage.removeItem("cart_token");
  //       setCartCount(0);
  //       await fetchAddresses();
  //       navigate("/order-confirm", {
  //         replace: true,
  //         state: { orderId: res.data.order_id, billingId: res.data.billing_id },
  //       });
  //     } else {
  //       alert(res.data.message || "Failed to place order");
  //       setIsPlacingOrder(false);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     alert(`Error: ${error.response?.data?.message || error.message}`);
  //     setIsPlacingOrder(false);
  //   }
  // };


/* ================= PLACE ORDER (WITH RAZORPAY) ================= */
const handlePlaceOrder = async () => {
  console.log("Current Payment Mode =", paymentMode);
  console.log("🔴 ========== PLACE ORDER START ==========");

  if (isPlacingOrder) return;
  if (!selectedAddress) {
    alert("Please select or add a delivery address");
    return;
  }
  if (!cartItems || cartItems.length === 0) {
    alert("Your cart is empty. Please add items first.");
    navigate("/");
    return;
  }
  if (cartItems.filter((i) => !i.prod_id).length > 0) {
    alert("Cart items are invalid. Please refresh and try again.");
    return;
  }

  setIsPlacingOrder(true);

  try {
    // ══════════════════════════════════════════
    // BUILD COMMON PAYLOAD
    // ══════════════════════════════════════════


    // Nikita code 3pecie 5 pecie logic add karne ke phele
    // const cartItemsPayload = buyNowData
    //   ? [
    //       {
    //         prod_id: Number(buyNowData.prod_id),
    //         size_id: buyNowData.size_id
    //           ? Number(buyNowData.size_id)
    //           : null,
    //         qty: Number(buyNowData.qty),
    //         price: Number(
    //           buyNowData.variant_price || buyNowData.current_price
    //         ),
    //       },
    //     ]
    //   : cartItems.map((item) => ({
    //       prod_id: Number(item.prod_id),
    //       size_id: item.size_id ? Number(item.size_id) : null,
    //       qty: Number(item.cart_qty),
    //       price: Number(item.current_price),
    //     }));



    // 14july-2026 3[ecie 5 pecice logic add kanr eke bad wala code
        const cartItemsPayload = buyNowData
      ? [
          {
            prod_id: Number(buyNowData.prod_id),
            size_id: buyNowData.size_id
              ? Number(buyNowData.size_id)
              : null,
            qty: Number(buyNowData.qty),
            price: Number(
              buyNowData.variant_price || buyNowData.current_price
            ),
            // ★ NEW: Quantity set info bhejo
            price_type: buyNowData.price_type || "simple",
            selected_quantity_set: buyNowData.selected_quantity_set || null,
          },
        ]
      : cartItems.map((item) => ({
          prod_id: Number(item.prod_id),
          size_id: item.size_id ? Number(item.size_id) : null,
          qty: Number(item.cart_qty),
          price: Number(item.current_price),
          // ★ NEW: Quantity set info bhejo (cart se aaye items me bhi ho sakta hai)
          price_type: item.price_type || "simple",
          selected_quantity_set: item.selected_quantity_set || null,
        }));



  


    // 02-07-2026 client ne discount add karne ke bad vaal code 
    let payload = {
  user_id: userId ? Number(userId) : null,
  cart_token: userId ? null : cartToken,
  cart_items: cartItemsPayload,
  payment_mode: paymentMode,
  discount: parsePrice(orderSummary.discount),
  shipping_total: shippingEnabled
    ? parsePrice(orderSummary.shipping)
    : 0,
};



    // Address data
    if (!isNewAddress && selectedAddress) {
      payload = {
        ...payload,
        billing_id: Number(selectedAddress.billing_id),
        first_name: selectedAddress.first_name,
        last_name: selectedAddress.last_name,
        email: selectedAddress.email,
        phone: selectedAddress.phone,
        company_name: selectedAddress.company_name || "",
        address1: selectedAddress.address1,
        location: selectedAddress.location || "",
        city: selectedAddress.city,
        state: selectedAddress.state,
        pin_code: selectedAddress.pin_code,
        address_type: selectedAddress.address_type,
        add_information: selectedAddress.add_information || "",
        country: "India",
      };
    }

    if (isNewAddress && selectedAddress?.isNew) {
      payload = {
        ...payload,
        first_name: selectedAddress.first_name,
        last_name: selectedAddress.last_name,
        email: selectedAddress.email,
        phone: selectedAddress.phone,
        company_name: selectedAddress.company_name || "",
        address1: selectedAddress.address1,
        location: selectedAddress.location || "",
        city: selectedAddress.city,
        state: selectedAddress.state,
        pin_code: selectedAddress.pin_code,
        address_type: selectedAddress.address_type,
        add_information: selectedAddress.add_information || "",
        country: "India",
      };
    }

    const appliedCouponId = localStorage.getItem("applied_coupon_id");
    if (appliedCouponId) payload.coupon_id = Number(appliedCouponId);

    // ══════════════════════════════════════════
    // CASH ON DELIVERY → PLACE ORDER DIRECTLY
    // ══════════════════════════════════════════
    if (paymentMode === "Cash") {
      console.log("🔴 COD MODE — Placing order directly");
      console.log("🔴 FINAL PAYLOAD:", JSON.stringify(payload, null, 2));

      const res = await axios.post(
        `${BASE_URL}/index.php/Api/place_order`,
        payload
      );
      console.log("🔴 API RESPONSE:", res.data);

      if (res.data.status === true || res.data.success === "1") {
        sessionStorage.removeItem("buyNowProduct");
        setCartItems([]);
        setOrderSummary({
          subtotal: "0.00",
          discount: "0.00",
          shipping: "0.00",
          grandTotal: "0.00",
        });
        alert("Order placed successfully!");
        localStorage.removeItem("applied_coupon_id");
        localStorage.removeItem("cart_token");
        setCartCount(0);
        await fetchAddresses();
        navigate("/order-confirm", {
          replace: true,
          state: {
            orderId: res.data.order_id,
            billingId: res.data.billing_id,
          },
        });
      } else {
        alert(res.data.message || "Failed to place order");
        setIsPlacingOrder(false);
      }
      return;
    }

    // ══════════════════════════════════════════
    // PREPAID → RAZORPAY PAYMENT FLOW
    // ══════════════════════════════════════════
    if (paymentMode === "Prepaid") {
       console.log("✅ PREPAID BLOCK ENTERED");
      alert("PREPAID BLOCK ENTERED");

      console.log("🔴 PREPAID MODE — Starting Razorpay flow");

      const grandTotal = parsePrice(orderSummary.grandTotal);

      if (grandTotal <= 0) {
        alert("Invalid order amount");
        setIsPlacingOrder(false);
        return;
      }

      // ── Step A: Create Razorpay Order on Backend ──
      console.log("🔴 Step A: Creating Razorpay order for ₹" + grandTotal);

      const razorpayOrderRes = await axios.post(
        `${BASE_URL}/index.php/Api/create_razorpay_order`,
        { amount: grandTotal }
      );

      if (
        !razorpayOrderRes.data.status ||
        !razorpayOrderRes.data.order_id
      ) {
        alert(
          "Failed to create payment order: " +
            (razorpayOrderRes.data.message || "Unknown error")
        );
        setIsPlacingOrder(false);
        return;
      }

      const razorpayOrderId = razorpayOrderRes.data.order_id;
      console.log("🔴 Razorpay Order Created:", razorpayOrderId);

      // ── Step B: Open Razorpay Checkout ──
      const paymentCompleted = await new Promise((resolve) => {
        const options = {
          key: RAZORPAY_KEY_ID,             // Your public Key ID
          amount: grandTotal * 100,          // Amount in paise
          currency: "INR",
          name: "ShopIndia",
          description: `Order Payment - ₹${grandTotal}`,
          order_id: razorpayOrderId,         // From Step A
          // Prefill user details from selected address
          prefill: {
            name:
              (selectedAddress.first_name || "") +
              " " +
              (selectedAddress.last_name || ""),
            email: selectedAddress.email || "",
            contact: selectedAddress.phone || "",
          },
          theme: {
            color: "#24aeb1",                // Your brand color
          },
          // ✅ SUCCESS handler
          handler: function (response) {
            console.log("🔴 Razorpay Payment Success:", response);
            resolve({
              success: true,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
            });
          },
          // ❌ MODAL CLOSED / PAYMENT FAILED
          modal: {
            ondismiss: function () {
              console.log("🔴 Razorpay modal closed by user");
              resolve({ success: false, reason: "modal_closed" });
            },
          },
        };

        console.log("window.Razorpay =", window.Razorpay);
alert("Opening Razorpay");

        const rzp = new window.Razorpay(options);
        rzp.on("payment.failed", function (response) {
          console.error("🔴 Razorpay Payment Failed:", response.error);
          resolve({ success: false, reason: "payment_failed" });
        });
        rzp.open();
      });

      // ── Step C: Check if payment was completed ──
      if (!paymentCompleted.success) {
        if (paymentCompleted.reason === "modal_closed") {
          alert("Payment cancelled. Your order was not placed.");
        } else {
          alert("Payment failed. Please try again.");
        }
        setIsPlacingOrder(false);
        return;
      }

      // ── Step D: Verify Payment on Backend ──
      console.log("🔴 Step D: Verifying payment on backend...");

      const verifyRes = await axios.post(
        `${BASE_URL}/index.php/Api/verify_razorpay_payment`,
        {
          razorpay_order_id: paymentCompleted.razorpay_order_id,
          razorpay_payment_id: paymentCompleted.razorpay_payment_id,
          razorpay_signature: paymentCompleted.razorpay_signature,
        }
      );

      if (!verifyRes.data.status) {
        alert(
          "Payment verification failed! Do NOT worry — your money is safe. Contact support."
        );
        setIsPlacingOrder(false);
        return;
      }

      console.log("🔴 Payment VERIFIED ✅");

      // ── Step E: Place Order (only after verified payment) ──
      // Add Razorpay payment details to the order payload
      payload.razorpay_payment_id = paymentCompleted.razorpay_payment_id;
      payload.razorpay_order_id = paymentCompleted.razorpay_order_id;
      payload.payment_status = "Paid";

      console.log(
        "🔴 Step E: Placing order with payment proof..."
      );
      console.log("🔴 FINAL PAYLOAD:", JSON.stringify(payload, null, 2));

      const res = await axios.post(
        `${BASE_URL}/index.php/Api/place_order`,
        payload
      );
      console.log("🔴 API RESPONSE:", res.data);

      if (res.data.status === true || res.data.success === "1") {
        sessionStorage.removeItem("buyNowProduct");
        setCartItems([]);
        setOrderSummary({
          subtotal: "0.00",
          discount: "0.00",
          shipping: "0.00",
          grandTotal: "0.00",
        });
        alert("Order placed successfully! Payment received.");
        localStorage.removeItem("applied_coupon_id");
        localStorage.removeItem("cart_token");
        setCartCount(0);
        await fetchAddresses();
        navigate("/order-confirm", {
          replace: true,
          state: {
            orderId: res.data.order_id,
            billingId: res.data.billing_id,
            razorpay_payment_id: paymentCompleted.razorpay_payment_id,
          },
        });
      } else {
        alert(
          "Payment was successful but order creation failed. Please contact support with payment ID: " +
            paymentCompleted.razorpay_payment_id
        );
        setIsPlacingOrder(false);
      }
    }
  } catch (error) {
    console.error("Place order error:", error);
    alert("Error: " + (error.response?.data?.message || error.message));
    setIsPlacingOrder(false);
  }
};


  /* ================= COUPON FILTERING ================= */
  const currentTotal = parsePrice(orderSummary.subtotal);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const eligibleCoupons = coupons.filter((coupon) => {
    const minVal        = parsePrice(coupon.min_order_value);
    const couponEndDate = new Date(coupon.end_date);
    couponEndDate.setHours(23, 59, 59, 999);
    return coupon.status === "active" && currentTotal >= minVal && today <= couponEndDate;
  });

  const handleDeleteAddress = async (billing_id) => {
  if (!window.confirm("Are you sure you want to delete this address?")) return;

  try {
    const res = await axios.post(
      `${BASE_URL}/index.php/Api/delete_User_Address_By_Id`,
      {
        user_id: userId,
        billing_id: billing_id,
      }
    );

    if (res.data.status === "true") {
      // alert("Address deleted successfully");

      // UI se remove karo without reload
      setAddresses((prev) =>
        prev.filter((addr) => addr.billing_id !== billing_id)
      );

      // Agar deleted address selected tha to reset karo
      if (selectedAddress?.billing_id === billing_id) {
        setSelectedAddress(null);
      }

    } else {
      alert(res.data.message || "Failed to delete address");
    }
  } catch (error) {
    console.error(error);
    alert("Something went wrong");
  }
};

  /* ================= RENDER ================= */
  return (
    <div className="container my-5">
      <h4 className="fw-bold mb-4">BILLING DETAILS</h4>
      <div className="row g-4">

        {/* ── LEFT SIDE ── */}
        <div className="col-md-8">
          <div className="border p-4 rounded-2">
            <h6 className="fw-bold mb-3">Billing Information</h6>

            <div className="row g-md-4 g-3 mb-3">
              <div className="col-md-6">
                <input name="first_name" value={form.first_name} onChange={handleChange} className="form-control" placeholder="First Name *" />
              </div>
              <div className="col-md-6">
                <input name="last_name" value={form.last_name} onChange={handleChange} className="form-control" placeholder="Last Name *" />
              </div>
            </div>

            <div className="row mb-3 g-md-4 g-3">
              <div className="col-md-6">
                <input name="email" value={form.email} onChange={handleChange} className="form-control" placeholder="Email" />
              </div>
              <div className="col-md-6">
                <input name="phone" value={form.phone} onChange={handleChange} className="form-control" placeholder="Phone *" />
              </div>
            </div>

            <input name="company_name" value={form.company_name} onChange={handleChange} className="form-control mb-3" placeholder="Company Name (Optional)" />

            <h6 className="fw-bold mb-3">ADDRESS</h6>
            <input name="pin_code"  value={form.pin_code}  onChange={handleChange} className="form-control mb-2" placeholder="Pin Code *" />
            <input name="address1"  value={form.address1}  onChange={handleChange} className="form-control mb-2" placeholder="Address *" />
            <input name="location"  value={form.location}  onChange={handleChange} className="form-control mb-2" placeholder="Location" />

            <div className="row mb-3 g-md-4 g-2">
              <div className="col-md-6">
                <input name="city"  value={form.city}  onChange={handleChange} className="form-control" placeholder="City *" />
              </div>
              <div className="col-md-6">
                <input name="state" value={form.state} onChange={handleChange} className="form-control" placeholder="State *" />
              </div>
            </div>

            <textarea
              name="add_information" value={form.add_information} onChange={handleChange}
              className="form-control mb-3" placeholder="Additional Information" rows="2"
            />

            <strong>ADDRESS TYPE</strong>
            <div className="mb-3">
              <label className="me-3">
                <input type="radio" checked={form.address_type === "home"}   onChange={() => setForm({ ...form, address_type: "home" })}   /> Home
              </label>
              <label>
                <input type="radio" checked={form.address_type === "office"} onChange={() => setForm({ ...form, address_type: "office" })} /> Office
              </label>
            </div>

            <button onClick={addNewAddressToList} className="bg-col text-white w-100 py-2 border-0 rounded-2 fw-bold mb-4">
              ADD NEW ADDRESS
            </button>

            {/* SAVED ADDRESSES */}
            {userId && (
              <>
                <h6 className="fw-bold mb-3">
                  {isNewAddress && selectedAddress?.isNew ? "NEW ADDRESS (Will be saved)" : "DELIVERY ADDRESS"}
                </h6>

                {isNewAddress && selectedAddress?.isNew && (
                  <div className="border rounded-2 p-3 mb-3 bg-light">
                    <label className="d-flex gap-2 w-100">
                      <input type="radio" name="selectAddress" checked readOnly />
                      <div>
                        <p className="mb-1 fw-semibold">
                          {selectedAddress.first_name} {selectedAddress.last_name}
                          <span className="badge bg-success ms-2 small">NEW</span>
                        </p>
                        <p className="mb-1">{selectedAddress.address1}</p>
                        <small>{selectedAddress.city}, {selectedAddress.state} - {selectedAddress.pin_code}</small>
                      </div>
                    </label>
                  </div>
                )}

                {addresses.length === 0 && !isNewAddress && (
                  <p className="text-muted">No saved addresses.</p>
                )}

                {addresses.map((addr) => (
                  <div
                    key={addr.billing_id}
                    className={`border rounded-2 p-3 mb-3 ${
                      !isNewAddress && selectedAddress?.billing_id === addr.billing_id
                        ? "border-primary bg-light" : ""
                    }`}
                  >
                    {/* <div className="d-flex justify-content-between"> */}
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2">
                      <label className="d-flex gap-2 w-100">
                        <input
                          type="radio" name="selectAddress"
                          checked={!isNewAddress && selectedAddress?.billing_id === addr.billing_id}
                          onChange={() => handleSelectAddress(addr)}
                        />
                        <div>
                          <p className="mb-1 fw-semibold">{addr.first_name} {addr.last_name}</p>
                          <p className="mb-1">{addr.address1}</p>
                          <small>{addr.city}, {addr.state} - {addr.pin_code}</small>
                        </div>
                      </label>
                      {/* <button
                        onClick={() => handleSelectAddress(addr)}
                        className="bg-col text-white border-0 px-3 py-1 rounded-2"
                      >
                        DELIVER HERE
                      </button> */}

                      <div className="d-flex flex-md-column flex-row justify-content-between align-items-end gap-2 w-100 w-md-auto mt-2 mt-md-0">

  <button
  onClick={() => handleSelectAddress(addr)}
  className="bg-col text-white border-0 rounded-2 w-50 w-md-100 py-1 py-md-2 small"
>
  DELIVER HERE
</button>

<button
  onClick={() => handleDeleteAddress(addr.billing_id)}
  className="bg-col text-white border-0 rounded-2 w-50 w-md-100 py-1 py-md-2 small"
>
  REMOVE
</button>

</div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>

        {/* ── RIGHT SIDE ── */}
        <div className="col-md-4">
          <h5 className="fw-bold mb-3">Payment Mode</h5>

          <div className={`p-3 border ${!paymentSettings.cod ? "opacity-50" : ""}`}>
            <label className="d-flex align-items-center">
              <input
                type="radio" disabled={!paymentSettings.cod} checked={paymentMode === "Cash"}
                onChange={() => { setPaymentMode("Cash"); localStorage.setItem("payment_mode", "Cash"); }}
                className="me-2"
              />
              Cash On Delivery
              {!paymentSettings.cod && <small className="text-danger ms-2">(Disabled by Admin)</small>}
            </label>
          </div>

          <div className={`p-3 border ${!paymentSettings.prepaid ? "opacity-50" : ""}`}>
            <label className="d-flex align-items-center">
              <input
                type="radio" disabled={!paymentSettings.prepaid} checked={paymentMode === "Prepaid"}
                onChange={() => { console.log("PAYMENT MODE = PREPAID");
                  setPaymentMode("Prepaid"); localStorage.setItem("payment_mode", "Prepaid"); }}
                className="me-2"
              />
              Prepaid (Online Payment)
            </label>
          </div>

          {userId && (
            <>
              {/* COUPONS */}
              <div className="border p-4 shadow-sm mt-3 mb-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0">Available Coupons</h5>
                  <button onClick={() => navigate("/coupon")} className="btn btn-sm btn-link text-decoration-none">
                    Show All
                  </button>
                </div>

                {/* Applied coupon banner */}
                {appliedCoupon && (
                  <div className="alert alert-success py-2 px-3 mb-3 d-flex justify-content-between align-items-center">
                    <small>
                      ✓ Coupon <strong>{appliedCoupon.code}</strong> applied — saved ₹{orderSummary.discount}
                    </small>
                    <button
                      className="btn btn-sm btn-link text-danger p-0 ms-2"
                      onClick={handleRemoveCoupon}
                    >
                      Remove
                    </button>
                  </div>
                )}

                {eligibleCoupons.length === 0 ? (
                  <p className="text-muted small">
                    No eligible coupons for your order.{" "}
                    <span
                      onClick={() => navigate("/coupon")}
                      style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                    >
                      View all coupons
                    </span>
                  </p>
                ) : (
                  eligibleCoupons.map((coupon) => {
                    const isApplied = appliedCoupon?.coupon_id === coupon.coupon_id;
                    return (
                      <div
                        key={coupon.coupon_id}
                        className="border rounded-2 p-3 mb-3"
                        style={{ backgroundColor: isApplied ? "#e8f5e9" : "#fff" }}
                      >
                        <h6 className="fw-bold mb-1">{coupon.coupon_name}</h6>
                        <p className="text-primary mb-2 small">
                          {coupon.discount_type === "percent"
                            ? `${coupon.discount_value}% OFF (max ₹${coupon.max_discount}) on orders above ₹${coupon.min_order_value}`
                            : `₹${coupon.discount_value} OFF on orders above ₹${coupon.min_order_value}`
                          }
                        </p>
                        <div className="d-flex justify-content-end">
                          <button
                            onClick={() => handleApplyCoupon(coupon)}
                            className="border-0 px-3 py-1 rounded-1 text-white small"
                            style={{
                              backgroundColor: isApplied ? "#4caf50" : "#24aeb1",
                              cursor:          isApplied ? "default" : "pointer",
                            }}
                            disabled={isApplied}
                          >
                            {isApplied ? "Applied" : "Apply"}
                          </button>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>

              {/* ORDER SUMMARY */}
              <div className="border p-4">
                <h5 className="mb-3">Order Summary</h5>

                {cartItems.length > 0 ? (
                  cartItems.map((item) => (
                    <div key={item.prod_id} className="d-flex justify-content-between mb-2 small">
                      <span>
                        {item.Product_name}
                        {/* {item.size && <small className="text-muted"> ({item.size} mm)</small>} */}
                        {item.size && (
        <small className="text-muted d-block"> Size: {item.size}</small>
      )}
                      </span>
                      <span>{item.cart_qty} x ₹{item.current_price}</span>
                    </div>
                  ))
                ) : (
                  <p className="text-muted">No product found</p>
                )}

                <hr />

                <div className="d-flex justify-content-between mb-2">
                  <span>Subtotal</span>
                  <span>₹{orderSummary.subtotal}</span>
                </div>

                <div className="d-flex justify-content-between mb-2">
                  <span>Shipping</span>
                  <span>₹{shippingEnabled ? orderSummary.shipping : "0.00"}</span>
                </div>

                {parsePrice(orderSummary.discount) > 0 && (
                  <div className="d-flex justify-content-between mb-2 text-success">
                    <span>Discount</span>
                    <span>- ₹{orderSummary.discount}</span>
                  </div>
                )}

                <hr />

                <div className="d-flex justify-content-between fw-bold mb-3">
                  <span>Total</span>
                  <span>₹{orderSummary.grandTotal}</span>
                </div>

                <button
                  onClick={handlePlaceOrder}
                  className="bg-col text-white w-100 py-2 border-0 rounded-2 fw-bold"
                  disabled={!selectedAddress || isPlacingOrder}
                >
                  {isPlacingOrder ? "PLACING ORDER..." : "PLACE ORDER"}
                </button>

                {!selectedAddress && (
                  <small className="text-danger d-block mt-2 text-center">
                    Please select an address
                  </small>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default BillingDynamic;